/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    Datetime: string;
    JSON: any;
    Position: [number, number];
    Uuid: string;
};

export type Address = {
    city: Scalars["String"];
    country: Scalars["String"];
    latitude?: InputMaybe<Scalars["Float"]>;
    longitude?: InputMaybe<Scalars["Float"]>;
    postalZipCode: Scalars["String"];
    stateProvince: Scalars["String"];
    streetAddress: Scalars["String"];
};

export type AirHandlingEquipment = {
    __typename?: "AirHandlingEquipment";
    airHandlingEquipmentAverageInstallationYear?: Maybe<Scalars["Int"]>;
    airHandlingEquipmentCoolingType?: Maybe<AirHandlingEquipmentCoolingType>;
    airHandlingEquipmentExists: Scalars["Boolean"];
    airHandlingEquipmentHeatingType?: Maybe<AirHandlingEquipmentHeatingType>;
    airHandlingEquipmentSupplyAirRate?: Maybe<Scalars["Float"]>;
    airHandlingEquipmentType?: Maybe<AirHandlingEquipmentType>;
};

export enum AirHandlingEquipmentCoolingType {
    DirectExpansion = "direct_expansion",
    Hydronic = "hydronic",
}

export enum AirHandlingEquipmentHeatingType {
    ElectricResistance = "electric_resistance",
    Gas = "gas",
    Hydronic = "hydronic",
}

export type AirHandlingEquipmentInput = {
    airHandlingEquipmentAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    airHandlingEquipmentCoolingType?: InputMaybe<AirHandlingEquipmentCoolingType>;
    airHandlingEquipmentExists: Scalars["Boolean"];
    airHandlingEquipmentHeatingType?: InputMaybe<AirHandlingEquipmentHeatingType>;
    airHandlingEquipmentSupplyAirRate?: InputMaybe<Scalars["Float"]>;
    airHandlingEquipmentType?: InputMaybe<AirHandlingEquipmentType>;
};

export enum AirHandlingEquipmentType {
    ExhaustOnlyAirHandlingUnit = "exhaust_only_air_handling_unit",
    MakeUpAirUnit = "make_up_air_unit",
    PackagedAirHandlingUnit = "packaged_air_handling_unit",
    SplitAirHandlingUnit = "split_air_handling_unit",
    SuiteAirExchangers = "suite_air_exchangers",
    SuiteEnergyRecoveryVentilator = "suite_energy_recovery_ventilator",
}

export type AnnualCarbonEmissionsBaselineCardData = {
    __typename?: "AnnualCarbonEmissionsBaselineCardData";
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsElectricity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsNaturalGas?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type AnnualCarbonEmissionsBaselineChartData = {
    __typename?: "AnnualCarbonEmissionsBaselineChartData";
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type AnnualCarbonEmissionsByFuelChartData = {
    __typename?: "AnnualCarbonEmissionsByFuelChartData";
    endUseCarbonEmissions: Array<Maybe<EndUseCarbonEmissions>>;
    year?: Maybe<Scalars["Int"]>;
};

export type AnnualCarbonEmissionsCard = {
    __typename?: "AnnualCarbonEmissionsCard";
    data: Array<Maybe<AnnualCarbonEmissionsBaselineCardData>>;
    error?: Maybe<Scalars["String"]>;
};

export type AnnualCarbonEmissionsChart = {
    __typename?: "AnnualCarbonEmissionsChart";
    data: Array<Maybe<AnnualCarbonEmissionsBaselineChartData>>;
    error?: Maybe<Scalars["String"]>;
};

export type AnnualCarbonEmissionsRecommendationsCardData = {
    __typename?: "AnnualCarbonEmissionsRecommendationsCardData";
    averageCarbonEmissionIntensity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsElectricity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsNaturalGas?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsPercentChange?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type AnnualCarbonEmissionsRecommendationsChartData = {
    __typename?: "AnnualCarbonEmissionsRecommendationsChartData";
    totalCarbonEmissionsBaseline?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsGoal?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type AnnualEmissionSavingsByMeasureCategory = {
    __typename?: "AnnualEmissionSavingsByMeasureCategory";
    carbonReductionMeasureCategory?: Maybe<Scalars["String"]>;
    totalCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
};

export type AnnualEmissionSavingsByMeasureChartData = {
    __typename?: "AnnualEmissionSavingsByMeasureChartData";
    carbonEmissionSavingsFromGrid?: Maybe<Scalars["Float"]>;
    carbonReductionMeasureCategories: Array<Maybe<AnnualEmissionSavingsByMeasureCategory>>;
    remainingCarbonEmissions?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type AnnualEmissionSavingsByMeasureTableRow = {
    __typename?: "AnnualEmissionSavingsByMeasureTableRow";
    carbonReductionMeasureCategory?: Maybe<Scalars["String"]>;
    impactPercentage?: Maybe<Scalars["Float"]>;
    measureCount?: Maybe<Scalars["Int"]>;
    totalAnnualCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
    totalAnnualEnergyConsumptionSavings?: Maybe<Scalars["Float"]>;
    totalAnnualEnergyCostSavings?: Maybe<Scalars["Float"]>;
    totalMeasureCost?: Maybe<Scalars["Float"]>;
};

export type AnnualEndUseChart = {
    __typename?: "AnnualEndUseChart";
    carbonEmissions: Array<Maybe<EndUseValue>>;
    energyConsumption: Array<Maybe<EndUseValue>>;
    error?: Maybe<Scalars["String"]>;
    utilityCost: Array<Maybe<EndUseValue>>;
};

export type AnnualEnergyConsumptionCard = {
    __typename?: "AnnualEnergyConsumptionCard";
    data: Array<Maybe<AnnualEnergyConsumptionCardData>>;
    error?: Maybe<Scalars["String"]>;
};

export type AnnualEnergyConsumptionCardData = {
    __typename?: "AnnualEnergyConsumptionCardData";
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type AnnualEnergyConsumptionRecommendationsCardData = {
    __typename?: "AnnualEnergyConsumptionRecommendationsCardData";
    averageEnergyIntensity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionPercentChange?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionSavings?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type AverageMarginalAbatementCostByMeasureCategoryChartData = {
    __typename?: "AverageMarginalAbatementCostByMeasureCategoryChartData";
    averageMarginalAbatementCost?: Maybe<Scalars["Float"]>;
    carbonReductionMeasureCategory?: Maybe<Scalars["String"]>;
    totalLifetimeCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
};

export type BooleanFilter = {
    condition: BooleanFilterCondition;
    field: BooleanFilterField;
};

export enum BooleanFilterCondition {
    False = "FALSE",
    True = "TRUE",
    Has = "has",
}

export enum BooleanFilterField {
    IsPublished = "is_published",
    IsReported = "is_reported",
    PropertyName = "property_name",
}

export type BuildingBarChartAndMap = {
    __typename?: "BuildingBarChartAndMap";
    annualCarbonEmissionIntensityCurrent: Scalars["Float"];
    annualCarbonEmissionsCurrent: Scalars["Float"];
    annualEnergyConsumptionCurrent: Scalars["Float"];
    annualEnergyUseIntensityCurrent: Scalars["Float"];
    buildingModelUid: Scalars["Uuid"];
    location: Location;
};

export type BuildingBarChartAndMapByProperty = {
    __typename?: "BuildingBarChartAndMapByProperty";
    averageAnnualCarbonEmissionIntensityCurrent: Scalars["Float"];
    averageAnnualEnergyUseIntensityCurrent: Scalars["Float"];
    latitude: Scalars["Float"];
    longitude: Scalars["Float"];
    propertyName: Scalars["String"];
    totalAnnualCarbonEmissionsCurrent: Scalars["Float"];
    totalAnnualEnergyConsumptionCurrent: Scalars["Float"];
};

export type BuildingFilter = {
    buildingTypes?: InputMaybe<Array<InputMaybe<BuildingTypes>>>;
    grossFloorAreaMax?: InputMaybe<Scalars["Int"]>;
    grossFloorAreaMin?: InputMaybe<Scalars["Int"]>;
    heatingTypes?: InputMaybe<Array<InputMaybe<HeatingTypes>>>;
    vintageMax?: InputMaybe<Scalars["Int"]>;
    vintageMin?: InputMaybe<Scalars["Int"]>;
};

export type BuildingFootprints = {
    __typename?: "BuildingFootprints";
    closestBuildingUid?: Maybe<Scalars["Uuid"]>;
    error?: Maybe<Scalars["String"]>;
    features: Array<FootprintPolygon>;
    latitude?: Maybe<Scalars["Float"]>;
    longitude?: Maybe<Scalars["Float"]>;
};

export type BuildingModel = {
    __typename?: "BuildingModel";
    baselineCrp?: Maybe<CarbonReductionPlan>;
    buildingArchetype: Scalars["String"];
    buildingHeight?: Maybe<Scalars["Float"]>;
    buildingModelUid: Scalars["Uuid"];
    buildingName?: Maybe<Scalars["String"]>;
    buildingUid?: Maybe<Scalars["Uuid"]>;
    carbonReductionPlans: Array<BuildingModelCarbonReductionPlan>;
    city?: Maybe<Scalars["String"]>;
    coolingMultiplier?: Maybe<Scalars["Float"]>;
    country?: Maybe<Scalars["String"]>;
    createdAt?: Maybe<Scalars["String"]>;
    domesticHotWaterMultiplier?: Maybe<Scalars["Float"]>;
    energyType?: Maybe<Scalars["String"]>;
    energyTypeFromEquipmentData?: Maybe<Scalars["String"]>;
    energyTypeFromUtilityData?: Maybe<Scalars["String"]>;
    equipmentDataHasSizeAndYear?: Maybe<Scalars["Boolean"]>;
    equipmentDataUploaded: Scalars["Boolean"];
    fansMultiplier?: Maybe<Scalars["Float"]>;
    floorsAboveGrade?: Maybe<Scalars["Int"]>;
    grossFloorArea?: Maybe<Scalars["Float"]>;
    hasBeenModelled: Scalars["Boolean"];
    hasLatestModel: Scalars["Boolean"];
    heatingMultiplier?: Maybe<Scalars["Float"]>;
    lastUpdated?: Maybe<Scalars["String"]>;
    latitude?: Maybe<Scalars["Float"]>;
    lightingMultiplier?: Maybe<Scalars["Float"]>;
    longitude?: Maybe<Scalars["Float"]>;
    modellingStatus?: Maybe<Scalars["String"]>;
    plugLoadMultiplier?: Maybe<Scalars["Float"]>;
    postalZipCode?: Maybe<Scalars["String"]>;
    processMultiplier?: Maybe<Scalars["Float"]>;
    propertyName?: Maybe<Scalars["String"]>;
    propertyUid?: Maybe<Scalars["Uuid"]>;
    pumpsMultiplier?: Maybe<Scalars["Float"]>;
    recommendedCrp?: Maybe<CarbonReductionPlan>;
    reportedCrp?: Maybe<CarbonReductionPlan>;
    stateProvince?: Maybe<Scalars["String"]>;
    streetAddress?: Maybe<Scalars["String"]>;
    utilityDataCompleted?: Maybe<Scalars["Boolean"]>;
    utilityDataUploaded: Scalars["Boolean"];
    ventilationRateMultiplier?: Maybe<Scalars["Float"]>;
    yearBuiltOriginal?: Maybe<Scalars["Int"]>;
};

export type BuildingModelAnnualCarbonEmissionsCard = {
    __typename?: "BuildingModelAnnualCarbonEmissionsCard";
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsElectricity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsNaturalGas?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type BuildingModelAnnualCarbonEmissionsCardData = {
    __typename?: "BuildingModelAnnualCarbonEmissionsCardData";
    totalCarbonEmissionIntensity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsElectricity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsNaturalGas?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsPercentChange?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type BuildingModelAnnualCarbonEmissionsChart = {
    __typename?: "BuildingModelAnnualCarbonEmissionsChart";
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type BuildingModelAnnualCarbonEmissionsChartData = {
    __typename?: "BuildingModelAnnualCarbonEmissionsChartData";
    totalCarbonEmissionsBaseline?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsRecommendations?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type BuildingModelAnnualEmissionSavingsByMeasureTableRow = {
    __typename?: "BuildingModelAnnualEmissionSavingsByMeasureTableRow";
    annualCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
    annualEnergyConsumptionSavings?: Maybe<Scalars["Float"]>;
    annualEnergyCostSavings?: Maybe<Scalars["Float"]>;
    carbonReductionMeasureCategory?: Maybe<Scalars["String"]>;
    carbonReductionMeasureType?: Maybe<Scalars["String"]>;
    impactPercentage?: Maybe<Scalars["Float"]>;
    incrementalCost?: Maybe<Scalars["Float"]>;
    likeForLikeCost?: Maybe<Scalars["Float"]>;
    yearApplied?: Maybe<Scalars["Int"]>;
};

export type BuildingModelAnnualEnergyConsumptionCard = {
    __typename?: "BuildingModelAnnualEnergyConsumptionCard";
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type BuildingModelAnnualEnergyConsumptionCardData = {
    __typename?: "BuildingModelAnnualEnergyConsumptionCardData";
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionPercentChange?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionSavings?: Maybe<Scalars["Float"]>;
    totalEnergyIntensity?: Maybe<Scalars["Float"]>;
    year?: Maybe<Scalars["Int"]>;
};

export type BuildingModelBaselineCumulativeCarbonEmissionsCard = {
    __typename?: "BuildingModelBaselineCumulativeCarbonEmissionsCard";
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsElectricity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsNaturalGas?: Maybe<Scalars["Float"]>;
};

export type BuildingModelCarbonReductionMeasuresTableRow = {
    __typename?: "BuildingModelCarbonReductionMeasuresTableRow";
    annualCarbonEmissionSavings: Scalars["Float"];
    annualCarbonTaxSavings: Scalars["Float"];
    annualEnergyConsumptionSavings: Scalars["Float"];
    annualEnergyCostSavings: Scalars["Float"];
    carbonReductionMeasureCategory: Scalars["String"];
    carbonReductionMeasureType: Scalars["String"];
    incrementalCost: Scalars["Float"];
    internalRateOfReturn?: Maybe<Scalars["Float"]>;
    likeForLikeCost: Scalars["Float"];
    marginalAbatementCost: Scalars["Float"];
    netPresentValue: Scalars["Float"];
    returnOnInvestment: Scalars["Float"];
    simplePayback: Scalars["Int"];
    totalMeasureCost: Scalars["Float"];
    totalMeasureCostIntensity: Scalars["Float"];
    yearApplied: Scalars["Int"];
};

export type BuildingModelCarbonReductionPlan = {
    __typename?: "BuildingModelCarbonReductionPlan";
    baselineCrp: CarbonReductionPlan;
    buildingModelRunUid: Scalars["Uuid"];
    buildingModelUid: Scalars["Uuid"];
    buildingStateIsOutdated: Scalars["Boolean"];
    createdAt: Scalars["String"];
    id: Scalars["Uuid"];
    isPublished: Scalars["Boolean"];
    isReported: Scalars["Boolean"];
    name: Scalars["String"];
    plan: CarbonReductionPlan;
    planType: Scalars["String"];
};

export type BuildingModelCarbonReductionPlanReports = {
    __typename?: "BuildingModelCarbonReductionPlanReports";
    annualCarbonEmissionsCard?: Maybe<Array<BuildingModelAnnualCarbonEmissionsCard>>;
    annualCarbonEmissionsChart?: Maybe<Array<BuildingModelAnnualCarbonEmissionsChart>>;
    annualCarbonEmissionsElectricityChart?: Maybe<Array<AnnualCarbonEmissionsByFuelChartData>>;
    annualCarbonEmissionsNaturalGasChart?: Maybe<Array<AnnualCarbonEmissionsByFuelChartData>>;
    annualEnergyConsumptionCard?: Maybe<Array<BuildingModelAnnualEnergyConsumptionCard>>;
    cumulativeCarbonEmissionsCard: BuildingModelBaselineCumulativeCarbonEmissionsCard;
    cumulativeEnergyConsumptionCard: BuildingModelCumulativeEnergyConsumptionCard;
    currentAnnualCarbonEmissionsCard: BuildingModelCurrentAnnualCarbonEmissionsCard;
    currentAnnualEndUseChart: BuildingModelCurrentAnnualEndUseChart;
    currentAnnualEnergyConsumptionCard: BuildingModelCurrentAnnualEnergyConsumptionCard;
    error?: Maybe<Scalars["String"]>;
};

export type BuildingModelConstruction = {
    __typename?: "BuildingModelConstruction";
    assumedCoolingEnergyType?: Maybe<Scalars["String"]>;
    assumedDhwEnergyType?: Maybe<Scalars["String"]>;
    assumedExitCapRate?: Maybe<Scalars["Float"]>;
    assumedExitYear?: Maybe<Scalars["Int"]>;
    assumedGrossAssetValue?: Maybe<Scalars["Float"]>;
    assumedHeatingEnergyType?: Maybe<Scalars["String"]>;
    availableRoofAreaRatio?: Maybe<Scalars["Float"]>;
    buildingArchetype?: Maybe<Scalars["String"]>;
    buildingFootprint?: Maybe<FootprintPolygon>;
    buildingHeight?: Maybe<Scalars["Float"]>;
    buildingUid?: Maybe<Scalars["Uuid"]>;
    coolingMultiplier?: Maybe<Scalars["Float"]>;
    customerBuildingIdentifier?: Maybe<Scalars["String"]>;
    defaultDiscountRate?: Maybe<Scalars["Float"]>;
    defaultElectricityUtilityRate?: Maybe<Scalars["Float"]>;
    defaultGridIntensityScheduleScenario?: Maybe<Scalars["String"]>;
    defaultLandlordShareCost?: Maybe<Scalars["Float"]>;
    defaultLandlordShareElectricity?: Maybe<Scalars["Float"]>;
    defaultLandlordShareNaturalGas?: Maybe<Scalars["Float"]>;
    defaultLandlordShareSteam?: Maybe<Scalars["Float"]>;
    defaultNaturalGasUtilityRate?: Maybe<Scalars["Float"]>;
    defaultSteamUtilityRate?: Maybe<Scalars["Float"]>;
    defaultUtilityInflationRate?: Maybe<Scalars["Float"]>;
    defaultWeightEmissionSavings?: Maybe<Scalars["Float"]>;
    defaultWeightNetPresentValue?: Maybe<Scalars["Float"]>;
    domesticHotWaterMultiplier?: Maybe<Scalars["Float"]>;
    error?: Maybe<Scalars["String"]>;
    fansMultiplier?: Maybe<Scalars["Float"]>;
    floorsAboveGrade?: Maybe<Scalars["Int"]>;
    footprintArea?: Maybe<Scalars["Float"]>;
    grossFloorArea?: Maybe<Scalars["Float"]>;
    heatingMultiplier?: Maybe<Scalars["Float"]>;
    leasingStructure?: Maybe<Scalars["String"]>;
    ledInstalledRatio?: Maybe<Scalars["Float"]>;
    lightingMultiplier?: Maybe<Scalars["Float"]>;
    location?: Maybe<Location>;
    notes?: Maybe<Scalars["String"]>;
    plugLoadMultiplier?: Maybe<Scalars["Float"]>;
    processMultiplier?: Maybe<Scalars["Float"]>;
    pumpsMultiplier?: Maybe<Scalars["Float"]>;
    roofArea?: Maybe<Scalars["Float"]>;
    roofInstallationYear?: Maybe<Scalars["Int"]>;
    roofRValue?: Maybe<Scalars["Float"]>;
    ventilationRateMultiplier?: Maybe<Scalars["Float"]>;
    wallRValue?: Maybe<Scalars["Float"]>;
    windowInstallationYear?: Maybe<Scalars["Int"]>;
    windowRValue?: Maybe<Scalars["Float"]>;
    windowSolarHeatGainCoefficient?: Maybe<Scalars["Float"]>;
    windowToWallRatio?: Maybe<Scalars["Float"]>;
    yearBuiltOriginal?: Maybe<Scalars["Int"]>;
};

export type BuildingModelCumulativeCarbonEmissionsCard = {
    __typename?: "BuildingModelCumulativeCarbonEmissionsCard";
    totalCarbonEmissionIntensity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsElectricity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsNaturalGas?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsPercentChange?: Maybe<Scalars["Float"]>;
};

export type BuildingModelCumulativeEnergyConsumptionCard = {
    __typename?: "BuildingModelCumulativeEnergyConsumptionCard";
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
};

export type BuildingModelCurrentAnnualCarbonEmissionsCard = {
    __typename?: "BuildingModelCurrentAnnualCarbonEmissionsCard";
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    totalEmissionIntensity?: Maybe<Scalars["Float"]>;
};

export type BuildingModelCurrentAnnualEndUseChart = {
    __typename?: "BuildingModelCurrentAnnualEndUseChart";
    carbonEmissions: Array<Maybe<EndUseValue>>;
    energyConsumption: Array<Maybe<EndUseValue>>;
    utilityCost: Array<Maybe<EndUseValue>>;
};

export type BuildingModelCurrentAnnualEnergyConsumptionCard = {
    __typename?: "BuildingModelCurrentAnnualEnergyConsumptionCard";
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEnergyIntensity?: Maybe<Scalars["Float"]>;
};

export type BuildingModelEnergyConsumptionCard = {
    __typename?: "BuildingModelEnergyConsumptionCard";
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionPercentChange?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionSavings?: Maybe<Scalars["Float"]>;
    totalEnergyIntensity?: Maybe<Scalars["Float"]>;
};

export type BuildingModelHeader = {
    __typename?: "BuildingModelHeader";
    buildingName: Scalars["String"];
    buildingStatus: BuildingStatus;
    dataCoverage: DataCoverage;
    fundName?: Maybe<Scalars["String"]>;
    location: Location;
    propertyName?: Maybe<Scalars["String"]>;
    tags: Array<Scalars["String"]>;
};

export type BuildingModelTagInput = {
    building_model_uid: Scalars["Uuid"];
    tags: Array<Scalars["String"]>;
};

export type BuildingModelUtilityData = {
    __typename?: "BuildingModelUtilityData";
    buildingModelUtilityData: Array<Maybe<BuildingModelUtilityDataRow>>;
    error?: Maybe<Scalars["String"]>;
};

export type BuildingModelUtilityDataRow = {
    __typename?: "BuildingModelUtilityDataRow";
    accountNumber?: Maybe<Scalars["String"]>;
    currency: Scalars["String"];
    endDate: Scalars["String"];
    energyConsumption: Scalars["Float"];
    energyConsumptionUnit: Scalars["String"];
    insertTime: Scalars["String"];
    startDate: Scalars["String"];
    utilityCost?: Maybe<Scalars["Float"]>;
    utilityProvider?: Maybe<Scalars["String"]>;
    utilityRate?: Maybe<Scalars["Float"]>;
    utilityType: UtilityTypes;
};

export type BuildingModelsTableRow = {
    __typename?: "BuildingModelsTableRow";
    annualCarbonEmissionIntensityCurrent?: Maybe<Scalars["Float"]>;
    annualCarbonEmissionsCurrent?: Maybe<Scalars["Float"]>;
    annualCarbonPolicyCostIntensityCurrent?: Maybe<Scalars["Float"]>;
    annualEnergyConsumptionCurrent?: Maybe<Scalars["Float"]>;
    annualEnergyUseIntensityCurrent?: Maybe<Scalars["Float"]>;
    annualUtilityCostIntensityCurrent?: Maybe<Scalars["Float"]>;
    averageMarginalAbatementCost?: Maybe<Scalars["Float"]>;
    buildingArchetype: Scalars["String"];
    buildingModelUid: Scalars["Uuid"];
    buildingName?: Maybe<Scalars["String"]>;
    buildingStatus: BuildingStatus;
    carbonEmissionReductionPotential?: Maybe<Scalars["Float"]>;
    createdAt: Scalars["Datetime"];
    dataCoverage: DataCoverage;
    fundName?: Maybe<Scalars["String"]>;
    grossFloorArea: Scalars["Float"];
    lastUpdated: Scalars["Datetime"];
    location: Location;
    netPresentValueIntensity?: Maybe<Scalars["Float"]>;
    propertyName?: Maybe<Scalars["String"]>;
    tags: Array<Scalars["String"]>;
    yearBuiltOriginal?: Maybe<Scalars["Int"]>;
};

export type BuildingProperties = {
    assumedCoolingEnergyType?: InputMaybe<Scalars["String"]>;
    assumedDhwEnergyType?: InputMaybe<Scalars["String"]>;
    assumedExitCapRate?: InputMaybe<Scalars["Float"]>;
    assumedExitYear?: InputMaybe<Scalars["Int"]>;
    assumedGrossAssetValue?: InputMaybe<Scalars["Float"]>;
    assumedHeatingEnergyType?: InputMaybe<Scalars["String"]>;
    availableRoofAreaRatio?: InputMaybe<Scalars["Float"]>;
    buildingArchetype?: InputMaybe<Scalars["String"]>;
    buildingFootprint?: InputMaybe<FootprintPolygonInput>;
    buildingHeight?: InputMaybe<Scalars["Float"]>;
    buildingUid?: InputMaybe<Scalars["Uuid"]>;
    coolingMultiplier?: InputMaybe<Scalars["Float"]>;
    customerBuildingIdentifier?: InputMaybe<Scalars["String"]>;
    defaultDiscountRate?: InputMaybe<Scalars["Float"]>;
    defaultElectricityUtilityRate?: InputMaybe<Scalars["Float"]>;
    defaultGridIntensityScheduleScenario?: InputMaybe<Scalars["String"]>;
    defaultLandlordShareCost?: InputMaybe<Scalars["Float"]>;
    defaultLandlordShareElectricity?: InputMaybe<Scalars["Float"]>;
    defaultLandlordShareNaturalGas?: InputMaybe<Scalars["Float"]>;
    defaultLandlordShareSteam?: InputMaybe<Scalars["Float"]>;
    defaultNaturalGasUtilityRate?: InputMaybe<Scalars["Float"]>;
    defaultSteamUtilityRate?: InputMaybe<Scalars["Float"]>;
    defaultUtilityInflationRate?: InputMaybe<Scalars["Float"]>;
    defaultWeightEmissionSavings?: InputMaybe<Scalars["Float"]>;
    defaultWeightNetPresentValue?: InputMaybe<Scalars["Float"]>;
    domesticHotWaterMultiplier?: InputMaybe<Scalars["Float"]>;
    energyType?: InputMaybe<Scalars["String"]>;
    fansMultiplier?: InputMaybe<Scalars["Float"]>;
    floorsAboveGrade?: InputMaybe<Scalars["Int"]>;
    grossFloorArea?: InputMaybe<Scalars["Float"]>;
    heatingMultiplier?: InputMaybe<Scalars["Float"]>;
    leasingStructure?: InputMaybe<Scalars["String"]>;
    ledInstalledRatio?: InputMaybe<Scalars["Float"]>;
    lightingMultiplier?: InputMaybe<Scalars["Float"]>;
    notes?: InputMaybe<Scalars["String"]>;
    plugLoadMultiplier?: InputMaybe<Scalars["Float"]>;
    processMultiplier?: InputMaybe<Scalars["Float"]>;
    pumpsMultiplier?: InputMaybe<Scalars["Float"]>;
    ventilationRateMultiplier?: InputMaybe<Scalars["Float"]>;
    yearBuiltOriginal?: InputMaybe<Scalars["Int"]>;
};

export type BuildingState = {
    __typename?: "BuildingState";
    grossFloorArea?: Maybe<Scalars["Float"]>;
};

export type BuildingStatus = {
    __typename?: "BuildingStatus";
    energyType: EnergyTypeEnum;
    equipmentDataUploaded: Scalars["Boolean"];
    footprintVerified: Scalars["Boolean"];
    hasLatestModel: Scalars["Boolean"];
    lastUpdated: Scalars["Datetime"];
    utilityDataCompleted: Scalars["Boolean"];
    utilityDataUploaded: Scalars["Boolean"];
};

export enum BuildingTypes {
    FoodRetailGrocery = "food_retail_grocery",
    FullServiceRestaurant = "full_service_restaurant",
    Hotel = "hotel",
    LongtermCare = "longterm_care",
    MedicalOffice = "medical_office",
    MultiUnitResidential = "multi_unit_residential",
    NonFoodRetailClosed = "non_food_retail_closed",
    NonFoodRetailOpen = "non_food_retail_open",
    Office = "office",
    QuickServiceRestaurant = "quick_service_restaurant",
    RecreationComplex = "recreation_complex",
    School = "school",
    Warehouse = "warehouse",
}

export type CarbonEmissionsCard = {
    __typename?: "CarbonEmissionsCard";
    averageCarbonEmissionIntensity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsElectricity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsNaturalGas?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsPercentChange?: Maybe<Scalars["Float"]>;
};

export type CarbonIntensityReductionEffect = {
    __typename?: "CarbonIntensityReductionEffect";
    fuel?: Maybe<Scalars["String"]>;
    id?: Maybe<Scalars["String"]>;
    percentReduction?: Maybe<Scalars["Int"]>;
};

export type CarbonReductionMeasure = {
    __typename?: "CarbonReductionMeasure";
    annualEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    annualEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
    annualEnergyConsumptionSteam?: Maybe<Scalars["Float"]>;
    annualMeanCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
    annualMeanUtilityCostSavings?: Maybe<Scalars["Float"]>;
    buildingState?: Maybe<BuildingState>;
    carbonIntensityReductionEffects: Array<ConsumptionReductionEffect>;
    carbonReductionMeasureCategory?: Maybe<Scalars["String"]>;
    carbonReductionMeasureId: Scalars["String"];
    carbonReductionMeasureSizeUnit?: Maybe<Scalars["String"]>;
    carbonReductionMeasureType: Scalars["String"];
    carbonReductionMeasureUid: Scalars["Uuid"];
    carbonTaxDollarPerTonne?: Maybe<Scalars["Float"]>;
    category: Scalars["String"];
    consumptionReductionEffects: Array<ConsumptionReductionEffect>;
    description: Scalars["String"];
    discountRate: Scalars["Float"];
    energyConsumptionSavingsElectricity?: Maybe<Scalars["Float"]>;
    energyConsumptionSavingsNaturalGas?: Maybe<Scalars["Float"]>;
    energyConsumptionSavingsSteam?: Maybe<Scalars["Float"]>;
    energyConsumptionSavingsTotal?: Maybe<Scalars["Float"]>;
    fuelCostReductionEffects: Array<FuelCostReductionEffect>;
    implementationStatus?: Maybe<Scalars["String"]>;
    incrementalCost?: Maybe<Scalars["Float"]>;
    internalRateOfReturnIncremental?: Maybe<Scalars["Float"]>;
    internalRateOfReturnTotal?: Maybe<Scalars["Float"]>;
    landlordShareCost: Scalars["Float"];
    landlordShareElectricity: Scalars["Float"];
    landlordShareNaturalGas: Scalars["Float"];
    landlordShareSteam: Scalars["Float"];
    lifetimeCarbonEmissionSavings?: Maybe<Array<Scalars["Float"]>>;
    lifetimeElectricityCarbonEmissionSavings: Scalars["Float"];
    lifetimeElectricityConsumptionSavings: Scalars["Float"];
    lifetimeElectricityUtilityCostSavings: Scalars["Float"];
    lifetimeNaturalGasCarbonEmissionSavings: Scalars["Float"];
    lifetimeNaturalGasConsumptionSavings: Scalars["Float"];
    lifetimeNaturalGasUtilityCostSavings: Scalars["Float"];
    lifetimeSteamCarbonEmissionSavings: Scalars["Float"];
    lifetimeSteamConsumptionSavings: Scalars["Float"];
    lifetimeSteamUtilityCostSavings: Scalars["Float"];
    lifetimeUtilityCostSavings?: Maybe<Array<Scalars["Float"]>>;
    likeForLikeCost?: Maybe<Scalars["Float"]>;
    likeForLikeLabourCost?: Maybe<Scalars["Float"]>;
    likeForLikeMaterialCost?: Maybe<Scalars["Float"]>;
    likeForLikeSize?: Maybe<Scalars["Float"]>;
    likeForLikeUnitCost?: Maybe<Scalars["Float"]>;
    loadReductionEffects: Array<LoadReductionEffect>;
    marginalAbatementCost?: Maybe<Scalars["Float"]>;
    marginalAbatementCostIncremental?: Maybe<Scalars["Float"]>;
    marginalAbatementCostTotal?: Maybe<Scalars["Float"]>;
    measureCost?: Maybe<Scalars["Float"]>;
    measureLabourCost?: Maybe<Scalars["Float"]>;
    measureLife?: Maybe<Scalars["Float"]>;
    measureMaterialCost?: Maybe<Scalars["Float"]>;
    measureSize?: Maybe<Scalars["Float"]>;
    measureUnitCost: Scalars["Float"];
    netIncrementalCost: Scalars["Float"];
    netPresentValue?: Maybe<Scalars["Float"]>;
    netPresentValueIncremental?: Maybe<Scalars["Float"]>;
    netPresentValueTotal?: Maybe<Scalars["Float"]>;
    netTotalCost: Scalars["Float"];
    notes?: Maybe<Scalars["String"]>;
    planLifetimeCarbonCostsAvoided?: Maybe<Scalars["Float"]>;
    returnOnInvestmentIncremental?: Maybe<Scalars["Float"]>;
    returnOnInvestmentTotal?: Maybe<Scalars["Float"]>;
    simplePaybackYearsIncremental?: Maybe<Scalars["Float"]>;
    simplePaybackYearsTotal?: Maybe<Scalars["Float"]>;
    sizeUnit: Scalars["String"];
    totalIncentives: Scalars["Float"];
    userProvidedCost: Scalars["Boolean"];
    userProvidedDescription: Scalars["Boolean"];
    userProvidedIncentives: Scalars["Boolean"];
    userProvidedLandlordShareCost: Scalars["Boolean"];
    userProvidedLandlordShareElectricity: Scalars["Boolean"];
    userProvidedLandlordShareNaturalGas: Scalars["Boolean"];
    userProvidedLandlordShareSteam: Scalars["Boolean"];
    userProvidedSize: Scalars["Boolean"];
    utilityCarbonIntensitiesElectricity?: Maybe<Scalars["Float"]>;
    utilityCarbonIntensitiesNaturalGas?: Maybe<Scalars["Float"]>;
    utilityCarbonIntensitiesSteam?: Maybe<Scalars["Float"]>;
    utilityRatesElectricity?: Maybe<Scalars["Float"]>;
    utilityRatesNaturalGas?: Maybe<Scalars["Float"]>;
    utilityRatesSteam?: Maybe<Scalars["Float"]>;
    yearApplied: Scalars["Int"];
};

export type CarbonReductionMeasureDecarbonizationPercentages = {
    __typename?: "CarbonReductionMeasureDecarbonizationPercentages";
    currentMeasure: Scalars["Float"];
    otherMeasureTypes: Scalars["Float"];
    sameMeasureTypes: Scalars["Float"];
};

export type CarbonReductionMeasureInput = {
    carbonIntensityReductionEffects?: InputMaybe<Scalars["JSON"]>;
    category?: InputMaybe<Scalars["String"]>;
    consumptionReductionEffects?: InputMaybe<Scalars["JSON"]>;
    crmId: Scalars["String"];
    description?: InputMaybe<Scalars["String"]>;
    fuelCostReductionEffects?: InputMaybe<Scalars["JSON"]>;
    implementationStatus?: InputMaybe<Scalars["String"]>;
    landlordShareCost?: InputMaybe<Scalars["Float"]>;
    landlordShareElectricity?: InputMaybe<Scalars["Float"]>;
    landlordShareNaturalGas?: InputMaybe<Scalars["Float"]>;
    landlordShareSteam?: InputMaybe<Scalars["Float"]>;
    lifetime?: InputMaybe<Scalars["Int"]>;
    likeForLikeCost?: InputMaybe<Scalars["Float"]>;
    loadReductionEffects?: InputMaybe<Scalars["JSON"]>;
    measureCost?: InputMaybe<Scalars["Float"]>;
    measureSize?: InputMaybe<Scalars["Float"]>;
    name?: InputMaybe<Scalars["String"]>;
    notes?: InputMaybe<Scalars["String"]>;
    revenueEffect?: InputMaybe<Scalars["JSON"]>;
    sizeUnit?: InputMaybe<Scalars["String"]>;
    totalIncentives?: InputMaybe<Scalars["Float"]>;
    year: Scalars["Int"];
};

export type CarbonReductionPlan = {
    __typename?: "CarbonReductionPlan";
    annualSummaries: Array<CarbonReductionPlanAnnualSummary>;
    buildingModelRunUid: Scalars["Uuid"];
    carbonReductionMeasures: Array<CarbonReductionMeasure>;
    carbonReductionPlanUid: Scalars["Uuid"];
    endYear: Scalars["Int"];
    scenarioType: Scalars["String"];
    startYear: Scalars["Int"];
};

export type CarbonReductionPlanAnnualSummary = {
    __typename?: "CarbonReductionPlanAnnualSummary";
    annualCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
    annualCarbonEmissions?: Maybe<Scalars["Float"]>;
    annualCarbonOffsetCost?: Maybe<Scalars["Float"]>;
    annualCarbonTax?: Maybe<Scalars["Float"]>;
    annualEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    annualEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
    annualEnergyConsumptionSavingsElectricity?: Maybe<Scalars["Float"]>;
    annualEnergyConsumptionSavingsNaturalGas?: Maybe<Scalars["Float"]>;
    annualSummaryUid: Scalars["Uuid"];
    annualUtilityCost?: Maybe<Scalars["Float"]>;
    annualUtilityCostSavings?: Maybe<Scalars["Float"]>;
    utilityCarbonIntensitiesElectricity?: Maybe<Scalars["Float"]>;
    utilityCarbonIntensitiesNaturalGas?: Maybe<Scalars["Float"]>;
    utilityRatesElectricity?: Maybe<Scalars["Float"]>;
    utilityRatesNaturalGas?: Maybe<Scalars["Float"]>;
    year: Scalars["Int"];
};

export type CarbonReductionPlanReport = {
    __typename?: "CarbonReductionPlanReport";
    annualCarbonEmissionsCard: Array<Maybe<BuildingModelAnnualCarbonEmissionsCardData>>;
    annualCarbonEmissionsChart: Array<Maybe<BuildingModelAnnualCarbonEmissionsChartData>>;
    annualCarbonEmissionsElectricityChart: Array<Maybe<AnnualCarbonEmissionsByFuelChartData>>;
    annualCarbonEmissionsNaturalGasChart: Array<Maybe<AnnualCarbonEmissionsByFuelChartData>>;
    annualEmissionSavingsByMeasureChart: Array<Maybe<AnnualEmissionSavingsByMeasureChartData>>;
    annualEmissionSavingsByMeasureTable: Array<Maybe<BuildingModelAnnualEmissionSavingsByMeasureTableRow>>;
    annualEndUse2050Chart?: Maybe<AnnualEndUseChart>;
    annualEnergyConsumptionCard: Array<Maybe<BuildingModelAnnualEnergyConsumptionCardData>>;
    averageMarginalAbatementCostByMeasureCategoryChart: Array<
        Maybe<AverageMarginalAbatementCostByMeasureCategoryChartData>
    >;
    cumulativeCarbonEmissionsCard: BuildingModelCumulativeCarbonEmissionsCard;
    cumulativeEmissionSavingsCard: CumulativeEmissionSavingsCard;
    cumulativeEnergyConsumptionCard: BuildingModelEnergyConsumptionCard;
    cumulativeInvestmentByDecarbonizationChart: Array<Maybe<CumulativeInvestmentByDecarbonizationChartData>>;
    error?: Maybe<Scalars["String"]>;
};

export type CentralPlantCooler = {
    __typename?: "CentralPlantCooler";
    centralPlantCoolerAverageInstallationYear?: Maybe<Scalars["Int"]>;
    centralPlantCoolerExists: Scalars["Boolean"];
    centralPlantCoolerSize?: Maybe<Scalars["Float"]>;
    centralPlantCoolerTerminalUnits?: Maybe<CentralPlantCoolerTerminalUnits>;
    centralPlantCoolerType?: Maybe<CentralPlantCoolerType>;
};

export type CentralPlantCoolerInput = {
    centralPlantCoolerAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    centralPlantCoolerExists: Scalars["Boolean"];
    centralPlantCoolerSize?: InputMaybe<Scalars["Float"]>;
    centralPlantCoolerTerminalUnits?: InputMaybe<CentralPlantCoolerTerminalUnits>;
    centralPlantCoolerType?: InputMaybe<CentralPlantCoolerType>;
};

export enum CentralPlantCoolerTerminalUnits {
    Baseboards = "baseboards",
    ConstantVolumeBoxes = "constant_volume_boxes",
    FanCoilUnits = "fan_coil_units",
    VariableAirVolumeBoxes = "variable_air_volume_boxes",
}

export enum CentralPlantCoolerType {
    AirCooledChiller = "air_cooled_chiller",
    WaterCooledChiller = "water_cooled_chiller",
}

export type CentralPlantHeatPump = {
    __typename?: "CentralPlantHeatPump";
    centralPlantHeatPumpAverageInstallationYear?: Maybe<Scalars["Int"]>;
    centralPlantHeatPumpExists: Scalars["Boolean"];
    centralPlantHeatPumpSize?: Maybe<Scalars["Float"]>;
    centralPlantHeatPumpType?: Maybe<CentralPlantHeatPumpType>;
};

export type CentralPlantHeatPumpInput = {
    centralPlantHeatPumpAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    centralPlantHeatPumpExists: Scalars["Boolean"];
    centralPlantHeatPumpSize?: InputMaybe<Scalars["Float"]>;
    centralPlantHeatPumpType?: InputMaybe<CentralPlantHeatPumpType>;
};

export enum CentralPlantHeatPumpType {
    AirSourceHeatPump = "air_source_heat_pump",
    GroundSourceHeatPump = "ground_source_heat_pump",
}

export type CentralPlantHeater = {
    __typename?: "CentralPlantHeater";
    centralPlantHeaterAverageInstallationYear?: Maybe<Scalars["Int"]>;
    centralPlantHeaterExists: Scalars["Boolean"];
    centralPlantHeaterSize?: Maybe<Scalars["Float"]>;
    centralPlantHeaterTerminalUnits?: Maybe<CentralPlantHeaterTerminalUnits>;
    centralPlantHeaterType?: Maybe<CentralPlantHeaterType>;
};

export type CentralPlantHeaterInput = {
    centralPlantHeaterAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    centralPlantHeaterExists: Scalars["Boolean"];
    centralPlantHeaterSize?: InputMaybe<Scalars["Float"]>;
    centralPlantHeaterTerminalUnits?: InputMaybe<CentralPlantHeaterTerminalUnits>;
    centralPlantHeaterType?: InputMaybe<CentralPlantHeaterType>;
};

export enum CentralPlantHeaterTerminalUnits {
    Baseboards = "baseboards",
    ConstantVolumeBoxes = "constant_volume_boxes",
    FanCoilUnits = "fan_coil_units",
    VariableAirVolumeBoxes = "variable_air_volume_boxes",
}

export enum CentralPlantHeaterType {
    CondensingGasBoiler = "condensing_gas_boiler",
    ElectricFurnace = "electric_furnace",
    ElectricResistanceBoiler = "electric_resistance_boiler",
    GasBoiler = "gas_boiler",
    GasFurnace = "gas_furnace",
    HighEfficiencyGasFurnace = "high_efficiency_gas_furnace",
    HydronicFurnace = "hydronic_furnace",
}

export enum ClothesDryersType {
    Electric = "electric",
    Gas = "gas",
}

export type ConsumptionReductionEffect = {
    __typename?: "ConsumptionReductionEffect";
    endUse?: Maybe<Scalars["String"]>;
    fuel?: Maybe<Scalars["String"]>;
    id?: Maybe<Scalars["String"]>;
    percentReduction?: Maybe<Scalars["Int"]>;
};

export type CreateBuildingModelResponse = {
    __typename?: "CreateBuildingModelResponse";
    buildingModelUid?: Maybe<Scalars["Uuid"]>;
    error?: Maybe<Scalars["String"]>;
};

export type CreateBuildingModelsResponse = {
    __typename?: "CreateBuildingModelsResponse";
    buildingModels?: Maybe<Array<Maybe<CreateBuildingModelResponse>>>;
    error?: Maybe<Scalars["String"]>;
};

export type CumulativeCarbonEmissionsCard = {
    __typename?: "CumulativeCarbonEmissionsCard";
    error?: Maybe<Scalars["String"]>;
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsElectricity?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionsNaturalGas?: Maybe<Scalars["Float"]>;
};

export type CumulativeEmissionSavingsCard = {
    __typename?: "CumulativeEmissionSavingsCard";
    totalCarbonEmissionSavings?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionSavingsFromGrid?: Maybe<Scalars["Float"]>;
    totalCarbonEmissionSavingsFromMeasures?: Maybe<Scalars["Float"]>;
};

export type CumulativeEnergyConsumptionCard = {
    __typename?: "CumulativeEnergyConsumptionCard";
    error?: Maybe<Scalars["String"]>;
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
};

export type CumulativeInvestmentByDecarbonizationChartData = {
    __typename?: "CumulativeInvestmentByDecarbonizationChartData";
    decarbonizationPercentage?: Maybe<Scalars["Float"]>;
    totalMeasureCost?: Maybe<Scalars["Float"]>;
};

export type CurrentAnnualCarbonEmissionsCard = {
    __typename?: "CurrentAnnualCarbonEmissionsCard";
    averageEmissionsIntensity?: Maybe<Scalars["Float"]>;
    error?: Maybe<Scalars["String"]>;
    totalCarbonEmissions?: Maybe<Scalars["Float"]>;
};

export type CurrentAnnualEnergyConsumptionCard = {
    __typename?: "CurrentAnnualEnergyConsumptionCard";
    averageEnergyIntensity: Scalars["Float"];
    error?: Maybe<Scalars["String"]>;
    totalEnergyConsumption: Scalars["Float"];
};

export type CurrentAnnualEnergyCostCard = {
    __typename?: "CurrentAnnualEnergyCostCard";
    landlordEnergyCost: Scalars["Float"];
    tenantEnergyCost: Scalars["Float"];
    totalEnergyCost: Scalars["Float"];
};

export type DataCoverage = {
    __typename?: "DataCoverage";
    dataCoverage: DataCoverageEnum;
    energyType: EnergyTypeEnum;
    energyTypeFromEquipmentData?: Maybe<EnergyTypeEnum>;
    energyTypeFromUtilityData?: Maybe<EnergyTypeEnum>;
    equipmentDataHasSizeAndYear: Scalars["Boolean"];
    equipmentDataUploaded: Scalars["Boolean"];
    modellingStatus: ModellingStatus;
    utilityDataUploaded: Scalars["Boolean"];
};

export enum DataCoverageEnum {
    Equipment = "equipment",
    EquipmentAndUtility = "equipment_and_utility",
    EquipmentAndUtilityWarning = "equipment_and_utility_warning",
    EquipmentWarning = "equipment_warning",
    Error = "error",
    NoEquipmentAndNoUtility = "no_equipment_and_no_utility",
    Processing = "processing",
    Utility = "utility",
    UtilityWarning = "utility_warning",
}

export type DomesticHotWaterHeater = {
    __typename?: "DomesticHotWaterHeater";
    domesticHotWaterHeaterAverageInstallationYear?: Maybe<Scalars["Int"]>;
    domesticHotWaterHeaterCentralDistribution: Scalars["Boolean"];
    domesticHotWaterHeaterExists: Scalars["Boolean"];
    domesticHotWaterHeaterSize?: Maybe<Scalars["Float"]>;
    domesticHotWaterHeaterType?: Maybe<DomesticHotWaterHeaterType>;
};

export type DomesticHotWaterHeaterInput = {
    domesticHotWaterHeaterAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    domesticHotWaterHeaterCentralDistribution: Scalars["Boolean"];
    domesticHotWaterHeaterExists: Scalars["Boolean"];
    domesticHotWaterHeaterSize?: InputMaybe<Scalars["Float"]>;
    domesticHotWaterHeaterType?: InputMaybe<DomesticHotWaterHeaterType>;
};

export enum DomesticHotWaterHeaterType {
    ElectricHeater = "electric_heater",
    GasHeater = "gas_heater",
    IndirectHeater = "indirect_heater",
}

export type EndUseCarbonEmissions = {
    __typename?: "EndUseCarbonEmissions";
    carbonEmissions?: Maybe<Scalars["Float"]>;
    endUse?: Maybe<Scalars["String"]>;
};

export type EndUseValue = {
    __typename?: "EndUseValue";
    endUse?: Maybe<Scalars["String"]>;
    fuelType?: Maybe<Scalars["String"]>;
    value?: Maybe<Scalars["Float"]>;
};

export type EnergyAggregation = {
    __typename?: "EnergyAggregation";
    averageUtilityRate?: Maybe<Scalars["Float"]>;
    endDate?: Maybe<Scalars["String"]>;
    lastUpdated?: Maybe<Scalars["String"]>;
    startDate?: Maybe<Scalars["String"]>;
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEntries?: Maybe<Scalars["Int"]>;
    totalUtilityCost?: Maybe<Scalars["Float"]>;
};

export type EnergyAggregationByUtilityType = {
    __typename?: "EnergyAggregationByUtilityType";
    electricity?: Maybe<EnergyAggregation>;
    error?: Maybe<Scalars["String"]>;
    naturalGas?: Maybe<EnergyAggregation>;
};

export type EnergyConsumptionCard = {
    __typename?: "EnergyConsumptionCard";
    averageEnergyIntensity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumption?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionElectricity?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionNaturalGas?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionPercentChange?: Maybe<Scalars["Float"]>;
    totalEnergyConsumptionSavings?: Maybe<Scalars["Float"]>;
};

export enum EnergyTypeEnum {
    Electric = "electric",
    ElectricInferred = "electric_inferred",
    Mixed = "mixed",
    MixedInferred = "mixed_inferred",
}

export type EquipmentSurvey = {
    __typename?: "EquipmentSurvey";
    airHandlingEquipment?: Maybe<AirHandlingEquipment>;
    centralPlantCooler?: Maybe<CentralPlantCooler>;
    centralPlantHeatPump?: Maybe<CentralPlantHeatPump>;
    centralPlantHeater?: Maybe<CentralPlantHeater>;
    domesticHotWaterHeater?: Maybe<DomesticHotWaterHeater>;
    error?: Maybe<Scalars["String"]>;
    genericHVACEquipment: Array<GenericHvacEquipment>;
    heatPump?: Maybe<HeatPump>;
    otherEquipment?: Maybe<OtherEquipment>;
    rooftopUnit?: Maybe<RooftopUnit>;
    terminalCooler?: Maybe<TerminalCooler>;
    terminalHeater?: Maybe<TerminalHeater>;
};

export type EquipmentSurveyInput = {
    airHandlingEquipment: AirHandlingEquipmentInput;
    centralPlantCooler: CentralPlantCoolerInput;
    centralPlantHeatPump: CentralPlantHeatPumpInput;
    centralPlantHeater: CentralPlantHeaterInput;
    domesticHotWaterHeater: DomesticHotWaterHeaterInput;
    genericHVACEquipment: Array<GenericHvacEquipmentInput>;
    heatPump: HeatPumpInput;
    otherEquipment: OtherEquipmentInput;
    rooftopUnit: RooftopUnitInput;
    terminalCooler: TerminalCoolerInput;
    terminalHeater: TerminalHeaterInput;
};

export enum FeatureType {
    Feature = "Feature",
}

export enum FeatureTypeInput {
    Feature = "Feature",
}

export type FootprintPolygon = {
    __typename?: "FootprintPolygon";
    geometry: FootprintPolygonGeometry;
    properties: FootprintPolygonProperties;
    type: FeatureType;
};

export type FootprintPolygonGeometry = {
    __typename?: "FootprintPolygonGeometry";
    coordinates: Array<Array<Scalars["Position"]>>;
    type: GeometryType;
};

export type FootprintPolygonGeometryInput = {
    coordinates: Array<Array<Scalars["Position"]>>;
    type: GeometryTypeInput;
};

export type FootprintPolygonInput = {
    geometry: FootprintPolygonGeometryInput;
    properties: FootprintPolygonPropertiesInput;
    type: FeatureTypeInput;
};

export type FootprintPolygonProperties = {
    __typename?: "FootprintPolygonProperties";
    buildingUid?: Maybe<Scalars["Uuid"]>;
    latitude: Scalars["Float"];
    longitude: Scalars["Float"];
};

export type FootprintPolygonPropertiesInput = {
    buildingUid?: InputMaybe<Scalars["String"]>;
    latitude?: InputMaybe<Scalars["Float"]>;
    longitude?: InputMaybe<Scalars["Float"]>;
};

export type FuelCostReductionEffect = {
    __typename?: "FuelCostReductionEffect";
    absoluteReduction?: Maybe<Scalars["Int"]>;
    fuel: Scalars["String"];
    id: Scalars["String"];
    percentReduction?: Maybe<Scalars["Int"]>;
};

export type Fund = {
    __typename?: "Fund";
    annualCarbonEmissionIntensityCurrent?: Maybe<Scalars["Float"]>;
    annualCarbonPolicyCostIntensityCurrent?: Maybe<Scalars["Float"]>;
    annualEnergyUseIntensityCurrent?: Maybe<Scalars["Float"]>;
    annualUtilityCostIntensityCurrent?: Maybe<Scalars["Float"]>;
    averageMarginalAbatementCost?: Maybe<Scalars["Float"]>;
    carbonEmissionReductionPotential?: Maybe<Scalars["Float"]>;
    fundId: Scalars["Int"];
    fundName: Scalars["String"];
    grossFloorArea: Scalars["Float"];
    netPresentValueIntensity?: Maybe<Scalars["Float"]>;
    properties: Array<FundProperty>;
};

export type FundProperty = {
    __typename?: "FundProperty";
    buildingModels: Array<FundPropertyBuildingModel>;
    propertyUid: Scalars["Uuid"];
};

export type FundPropertyBuildingModel = {
    __typename?: "FundPropertyBuildingModel";
    buildingModelUid: Scalars["Uuid"];
    buildingStatus: BuildingStatus;
    dataCoverage: DataCoverage;
    tags: Array<Scalars["String"]>;
};

export type GenericHvacEquipment = {
    __typename?: "GenericHVACEquipment";
    coefficientOfPerformance: Scalars["Float"];
    endUse: Scalars["String"];
    fuel: Scalars["String"];
    installationYear: Scalars["Int"];
    lifeSpan: Scalars["Int"];
    loadRatio: Scalars["Float"];
    name: Scalars["String"];
    size: Scalars["Float"];
    sizeUnits: Scalars["String"];
};

export type GenericHvacEquipmentInput = {
    coefficientOfPerformance: Scalars["Float"];
    endUse: Scalars["String"];
    fuel: Scalars["String"];
    installationYear: Scalars["Int"];
    lifeSpan: Scalars["Int"];
    loadRatio: Scalars["Float"];
    name: Scalars["String"];
    size: Scalars["Float"];
    sizeUnits: Scalars["String"];
};

export enum GeometryType {
    MultiPolygon = "MultiPolygon",
    Polygon = "Polygon",
}

export enum GeometryTypeInput {
    MultiPolygon = "MultiPolygon",
    Polygon = "Polygon",
}

export type HeatPump = {
    __typename?: "HeatPump";
    heatPumpCoolingCoefficientOfPerformance?: Maybe<Scalars["Float"]>;
    heatPumpCoolingLoadRatio?: Maybe<Scalars["Float"]>;
    heatPumpExists: Scalars["Boolean"];
    heatPumpHeatingCoefficientOfPerformance?: Maybe<Scalars["Float"]>;
    heatPumpHeatingLoadRatio?: Maybe<Scalars["Float"]>;
    heatPumpInstallationYear?: Maybe<Scalars["Int"]>;
    heatPumpSize?: Maybe<Scalars["Float"]>;
    heatPumpType?: Maybe<HeatPumpType>;
};

export type HeatPumpInput = {
    heatPumpCoolingCoefficientOfPerformance?: InputMaybe<Scalars["Float"]>;
    heatPumpCoolingLoadRatio?: InputMaybe<Scalars["Float"]>;
    heatPumpExists: Scalars["Boolean"];
    heatPumpHeatingCoefficientOfPerformance?: InputMaybe<Scalars["Float"]>;
    heatPumpHeatingLoadRatio?: InputMaybe<Scalars["Float"]>;
    heatPumpInstallationYear?: InputMaybe<Scalars["Int"]>;
    heatPumpSize?: InputMaybe<Scalars["Float"]>;
    heatPumpType?: InputMaybe<HeatPumpType>;
};

export enum HeatPumpType {
    SplitAirSourceHeatPump = "split_air_source_heat_pump",
    WaterLoopHeatPump = "water_loop_heat_pump",
}

export enum HeatingTypes {
    NaturalGasBoiler = "natural_gas_boiler",
    NaturalGasRooftopUnit = "natural_gas_rooftop_unit",
}

export type InternalAuthUser = {
    __typename?: "InternalAuthUser";
    customerAccountUid?: Maybe<Scalars["Uuid"]>;
    error?: Maybe<Scalars["String"]>;
    userId?: Maybe<Scalars["ID"]>;
    viewableBuildingModels: Array<Scalars["Uuid"]>;
};

export type LoadReductionEffect = {
    __typename?: "LoadReductionEffect";
    endUse: Scalars["String"];
    percentReduction: Scalars["Int"];
};

export type Location = {
    __typename?: "Location";
    city?: Maybe<Scalars["String"]>;
    climateZone?: Maybe<Scalars["String"]>;
    country?: Maybe<Scalars["String"]>;
    latitude?: Maybe<Scalars["Float"]>;
    longitude?: Maybe<Scalars["Float"]>;
    postalZipCode?: Maybe<Scalars["String"]>;
    stateProvince?: Maybe<Scalars["String"]>;
    streetAddress?: Maybe<Scalars["String"]>;
};

export type MeasureReportAnnualCashFlowChart = {
    __typename?: "MeasureReportAnnualCashFlowChart";
    incremental: Array<MeasureReportAnnualCashFlowChartIncremental>;
    total: Array<MeasureReportAnnualCashFlowChartTotal>;
};

export type MeasureReportAnnualCashFlowChartIncremental = {
    __typename?: "MeasureReportAnnualCashFlowChartIncremental";
    calendarYear: Scalars["Int"];
    carbonPolicyCostSavings: Scalars["Float"];
    cashFlowAnnual: Scalars["Float"];
    cashFlowCumulative: Scalars["Float"];
    incrementalCost: Scalars["Float"];
    revenue: Scalars["Float"];
    totalIncentives: Scalars["Float"];
    utilityCostSavingsElectricity: Scalars["Float"];
    utilityCostSavingsNaturalGas: Scalars["Float"];
};

export type MeasureReportAnnualCashFlowChartTotal = {
    __typename?: "MeasureReportAnnualCashFlowChartTotal";
    calendarYear: Scalars["Int"];
    carbonPolicyCostSavings: Scalars["Float"];
    cashFlowAnnual: Scalars["Float"];
    cashFlowCumulative: Scalars["Float"];
    incrementalCost: Scalars["Float"];
    likeForLikeCost: Scalars["Float"];
    revenue: Scalars["Float"];
    totalIncentives: Scalars["Float"];
    utilityCostSavingsElectricity: Scalars["Float"];
    utilityCostSavingsNaturalGas: Scalars["Float"];
};

export type MeasureReportDecarbonizationForecastAnnualData = {
    __typename?: "MeasureReportDecarbonizationForecastAnnualData";
    calendarYear: Scalars["Int"];
    carbonEmissionSavingsFromGrid: Scalars["Float"];
    carbonReductionMeasureTypes: Array<MeasureReportDecarbonizationForecastChartDataMeasures>;
    remainingCarbonEmissions: Scalars["Float"];
};

export type MeasureReportDecarbonizationForecastChart = {
    __typename?: "MeasureReportDecarbonizationForecastChart";
    annualData?: Maybe<Array<MeasureReportDecarbonizationForecastAnnualData>>;
    percentages?: Maybe<CarbonReductionMeasureDecarbonizationPercentages>;
};

export type MeasureReportDecarbonizationForecastChartDataMeasures = {
    __typename?: "MeasureReportDecarbonizationForecastChartDataMeasures";
    carbonEmissionSavings: Scalars["Float"];
    carbonReductionMeasureCategory: Scalars["String"];
    carbonReductionMeasureType: Scalars["String"];
};

export type MeasureReportTotalCarbonEmissionsCard = {
    __typename?: "MeasureReportTotalCarbonEmissionsCard";
    carbonEmissionIntensity: Scalars["Float"];
    totalCarbonEmissionSavings: Scalars["Float"];
    totalCarbonEmissionSavingsElectricity: Scalars["Float"];
    totalCarbonEmissionSavingsNaturalGas: Scalars["Float"];
    totalCarbonEmissions: Scalars["Float"];
    totalCarbonEmissionsElectricity: Scalars["Float"];
    totalCarbonEmissionsNaturalGas: Scalars["Float"];
};

export type MeasureReportTotalEnergyConsumptionCard = {
    __typename?: "MeasureReportTotalEnergyConsumptionCard";
    totalEnergyConsumptionElectricity: Scalars["Float"];
    totalEnergyConsumptionNaturalGas: Scalars["Float"];
    totalEnergyConsumptionSavings: Scalars["Float"];
    totalEnergyConsumptionSavingsElectricity: Scalars["Float"];
    totalEnergyConsumptionSavingsNaturalGas: Scalars["Float"];
};

export type MeasureReportViewData = {
    __typename?: "MeasureReportViewData";
    annualCashFlowChart?: Maybe<MeasureReportAnnualCashFlowChart>;
    decarbonizationForecastChart?: Maybe<MeasureReportDecarbonizationForecastChart>;
    totalCarbonEmissionsCard?: Maybe<MeasureReportTotalCarbonEmissionsCard>;
    totalEnergyConsumptionCard?: Maybe<MeasureReportTotalEnergyConsumptionCard>;
};

export type Member = {
    __typename?: "Member";
    createdTimestamp: Scalars["Datetime"];
    email: Scalars["String"];
    isActive: Scalars["Boolean"];
    roles: Array<Scalars["String"]>;
    userId: Scalars["Int"];
};

export enum ModellingStatus {
    Error = "error",
    Processing = "processing",
    Success = "success",
}

export type Mutation = {
    __typename?: "Mutation";
    addUsers: Array<Member>;
    batchedRemodelBuildingModels: Array<PassFailResponse>;
    createBuildingModelTags: PassFailResponse;
    createCustomPlanFromPlan: Scalars["Uuid"];
    createCustomerAccount: Scalars["Uuid"];
    createPasswordResetTicket: PasswordResetTicket;
    createReportFilterset?: Maybe<Scalars["Uuid"]>;
    createUser: Array<User>;
    deleteBuildingModelTags: PassFailResponse;
    deleteBuildingModelUtilityData: UpdateBuildingModelResponse;
    deleteBuildingModels: PassFailResponse;
    deleteCustomCarbonReductionPlan: Scalars["Uuid"];
    deleteEquipmentSurvey: UpdateBuildingModelResponse;
    error?: Maybe<Scalars["String"]>;
    publishPlan: Scalars["Uuid"];
    remodelBuildingModels: Array<PassFailResponse>;
    removeUser: Member;
    reportPlan: Scalars["Uuid"];
    setBuildingModelProperty: PassFailResponse;
    setPropertyFund: PassFailResponse;
    setRoles: Member;
    submitEquipmentSurvey: PassFailResponse;
    submitUtilityData: SubmitUtilityDataResponse;
    unpublishPlan: Scalars["Uuid"];
    unreportPlan: Scalars["Uuid"];
    updateBuildingModel: UpdateBuildingModelResponse;
    updateBuildingName: PassFailResponse;
    updateCustomPlanMeasures: Scalars["Uuid"];
    updateCustomPlanName: Scalars["Uuid"];
    updateReportedPlan: Scalars["Uuid"];
    user: Scalars["Boolean"];
};

export type MutationAddUsersArgs = {
    emails: Array<Scalars["String"]>;
};

export type MutationBatchedRemodelBuildingModelsArgs = {
    buildingModelUids: Array<InputMaybe<Scalars["Uuid"]>>;
};

export type MutationCreateBuildingModelTagsArgs = {
    data: Array<BuildingModelTagInput>;
};

export type MutationCreateCustomPlanFromPlanArgs = {
    carbonReductionPlanUid: Scalars["Uuid"];
    planName: Scalars["String"];
};

export type MutationCreateCustomerAccountArgs = {
    currencyCode: Scalars["String"];
    name: Scalars["String"];
};

export type MutationCreatePasswordResetTicketArgs = {
    userId: Scalars["ID"];
};

export type MutationCreateReportFiltersetArgs = {
    reportFilter?: InputMaybe<ReportFilter>;
};

export type MutationCreateUserArgs = {
    email: Scalars["String"];
};

export type MutationDeleteBuildingModelTagsArgs = {
    data: Array<BuildingModelTagInput>;
};

export type MutationDeleteBuildingModelUtilityDataArgs = {
    buildingModelUid: Scalars["Uuid"];
};

export type MutationDeleteBuildingModelsArgs = {
    buildingModelUids: Array<Scalars["Uuid"]>;
};

export type MutationDeleteCustomCarbonReductionPlanArgs = {
    carbonReductionPlanUid: Scalars["Uuid"];
};

export type MutationDeleteEquipmentSurveyArgs = {
    buildingModelUid: Scalars["Uuid"];
};

export type MutationPublishPlanArgs = {
    id: Scalars["Uuid"];
};

export type MutationRemodelBuildingModelsArgs = {
    buildingModelUids: Array<InputMaybe<Scalars["Uuid"]>>;
};

export type MutationRemoveUserArgs = {
    userId: Scalars["Int"];
};

export type MutationReportPlanArgs = {
    id: Scalars["Uuid"];
};

export type MutationSetBuildingModelPropertyArgs = {
    buildingModelUids: Array<Scalars["Uuid"]>;
    propertyName?: InputMaybe<Scalars["String"]>;
};

export type MutationSetPropertyFundArgs = {
    fundName?: InputMaybe<Scalars["String"]>;
    propertyUids: Array<Scalars["Uuid"]>;
};

export type MutationSetRolesArgs = {
    roles: Array<Scalars["String"]>;
    userId: Scalars["Int"];
};

export type MutationSubmitEquipmentSurveyArgs = {
    buildingModelUid: Scalars["Uuid"];
    equipmentSurvey: EquipmentSurveyInput;
};

export type MutationSubmitUtilityDataArgs = {
    buildingModelUid: Scalars["Uuid"];
    utilityData: Array<UtilityData>;
};

export type MutationUnpublishPlanArgs = {
    id: Scalars["Uuid"];
};

export type MutationUnreportPlanArgs = {
    id: Scalars["Uuid"];
};

export type MutationUpdateBuildingModelArgs = {
    buildingModelUid: Scalars["Uuid"];
    buildingProperties?: InputMaybe<BuildingProperties>;
    carbonPolicyIds?: InputMaybe<Array<Scalars["Int"]>>;
};

export type MutationUpdateBuildingNameArgs = {
    buildingModelUid: Scalars["Uuid"];
    buildingName: Scalars["String"];
};

export type MutationUpdateCustomPlanMeasuresArgs = {
    id: Scalars["Uuid"];
    measures?: InputMaybe<Array<InputMaybe<CarbonReductionMeasureInput>>>;
};

export type MutationUpdateCustomPlanNameArgs = {
    id: Scalars["Uuid"];
    name: Scalars["String"];
};

export type MutationUpdateReportedPlanArgs = {
    id: Scalars["Uuid"];
};

export type MutationUserArgs = {
    userInput: UserInput;
};

export type NumericFilter = {
    condition: NumericFilterCondition;
    field: NumericFilterField;
    value?: InputMaybe<Scalars["Float"]>;
};

export enum NumericFilterCondition {
    Equal = "equal",
    GreaterThanEqual = "greater_than_equal",
    LessThanEqual = "less_than_equal",
    NotEqual = "not_equal",
}

export enum NumericFilterField {
    AnnualCarbonEmissionIntensity = "annual_carbon_emission_intensity",
    AnnualCarbonEmissions = "annual_carbon_emissions",
    AnnualEnergyConsumption = "annual_energy_consumption",
    AnnualEnergyUseIntensity = "annual_energy_use_intensity",
    GrossFloorArea = "gross_floor_area",
    YearBuiltOriginal = "year_built_original",
}

export type Organization = {
    __typename?: "Organization";
    createdTimestamp: Scalars["Datetime"];
    currencyCode: Scalars["String"];
    customerAccountUid: Scalars["Uuid"];
    defaultDiscountRate?: Maybe<Scalars["Float"]>;
    defaultGridIntensityScheduleScenario?: Maybe<Scalars["String"]>;
    defaultLandlordShareCost?: Maybe<Scalars["Float"]>;
    defaultLandlordShareElectricity?: Maybe<Scalars["Float"]>;
    defaultLandlordShareNaturalGas?: Maybe<Scalars["Float"]>;
    defaultLandlordShareSteam?: Maybe<Scalars["Float"]>;
    defaultUtilityInflationRate?: Maybe<Scalars["Float"]>;
    defaultWeightEmissionSavings?: Maybe<Scalars["Float"]>;
    defaultWeightNetPresentValue?: Maybe<Scalars["Float"]>;
    exchangeRateOverride?: Maybe<Scalars["Float"]>;
    members?: Maybe<Array<Member>>;
    name: Scalars["String"];
    prohibitGenerativeAi?: Maybe<Scalars["Boolean"]>;
    skipRooftopDetection?: Maybe<Scalars["Boolean"]>;
    tags: Array<Maybe<Scalars["String"]>>;
};

export type OtherEquipment = {
    __typename?: "OtherEquipment";
    clothesDryersAverageInstallationYear?: Maybe<Scalars["Int"]>;
    clothesDryersEnergyDensity?: Maybe<Scalars["Float"]>;
    clothesDryersExists: Scalars["Boolean"];
    clothesDryersType?: Maybe<ClothesDryersType>;
    clothesWashersAverageInstallationYear?: Maybe<Scalars["Int"]>;
    clothesWashersEnergyDensity?: Maybe<Scalars["Float"]>;
    clothesWashersExists: Scalars["Boolean"];
    elevatorsAverageInstallationYear?: Maybe<Scalars["Int"]>;
    elevatorsExists: Scalars["Boolean"];
    elevatorsQuantity?: Maybe<Scalars["Int"]>;
    escalatorExists: Scalars["Boolean"];
    escalatorFloorAreaServed?: Maybe<Scalars["Int"]>;
    escalatorInstallationYear?: Maybe<Scalars["Int"]>;
    escalatorQuantity?: Maybe<Scalars["Int"]>;
    escalatorVariableFrequencyDrive?: Maybe<Scalars["Boolean"]>;
    rooftopPhotovoltaicsAverageInstallationYear?: Maybe<Scalars["Int"]>;
    rooftopPhotovoltaicsExists: Scalars["Boolean"];
    rooftopPhotovoltaicsSize?: Maybe<Scalars["Float"]>;
};

export type OtherEquipmentInput = {
    clothesDryersAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    clothesDryersEnergyDensity?: InputMaybe<Scalars["Float"]>;
    clothesDryersExists: Scalars["Boolean"];
    clothesDryersType?: InputMaybe<ClothesDryersType>;
    clothesWashersAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    clothesWashersEnergyDensity?: InputMaybe<Scalars["Float"]>;
    clothesWashersExists: Scalars["Boolean"];
    elevatorsAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    elevatorsExists: Scalars["Boolean"];
    elevatorsQuantity?: InputMaybe<Scalars["Int"]>;
    escalatorExists: Scalars["Boolean"];
    escalatorFloorAreaServed?: InputMaybe<Scalars["Int"]>;
    escalatorInstallationYear?: InputMaybe<Scalars["Int"]>;
    escalatorQuantity?: InputMaybe<Scalars["Int"]>;
    escalatorVariableFrequencyDrive?: InputMaybe<Scalars["Boolean"]>;
    rooftopPhotovoltaicsAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    rooftopPhotovoltaicsExists: Scalars["Boolean"];
    rooftopPhotovoltaicsSize?: InputMaybe<Scalars["Float"]>;
};

export type PassFailResponse = {
    __typename?: "PassFailResponse";
    error?: Maybe<Scalars["String"]>;
    success?: Maybe<Scalars["Boolean"]>;
};

export type PasswordResetTicket = {
    __typename?: "PasswordResetTicket";
    error?: Maybe<Scalars["String"]>;
    ticket?: Maybe<Scalars["String"]>;
};

export type PrefilteredBaselineReport = {
    __typename?: "PrefilteredBaselineReport";
    annualCarbonEmissionsCard: AnnualCarbonEmissionsCard;
    annualCarbonEmissionsChart: AnnualCarbonEmissionsChart;
    annualCarbonEmissionsElectricityChart: Array<Maybe<AnnualCarbonEmissionsByFuelChartData>>;
    annualCarbonEmissionsNaturalGasChart: Array<Maybe<AnnualCarbonEmissionsByFuelChartData>>;
    annualEnergyConsumptionCard: AnnualEnergyConsumptionCard;
    buildingBarChartAndMap: Array<BuildingBarChartAndMap>;
    buildingBarChartAndMapByProperty: Array<BuildingBarChartAndMapByProperty>;
    buildingCount: Scalars["Int"];
    cumulativeCarbonEmissionsCard: CumulativeCarbonEmissionsCard;
    cumulativeEnergyConsumptionCard: CumulativeEnergyConsumptionCard;
    currentAnnualCarbonEmissionsCard: CurrentAnnualCarbonEmissionsCard;
    currentAnnualEndUseChart: AnnualEndUseChart;
    currentAnnualEnergyConsumptionCard: CurrentAnnualEnergyConsumptionCard;
    currentAnnualEnergyCostCard: CurrentAnnualEnergyCostCard;
};

export type PrefilteredRecommendationsReport = {
    __typename?: "PrefilteredRecommendationsReport";
    annualCarbonEmissionsCard: Array<Maybe<AnnualCarbonEmissionsRecommendationsCardData>>;
    annualCarbonEmissionsChart: Array<Maybe<AnnualCarbonEmissionsRecommendationsChartData>>;
    annualCarbonEmissionsElectricityChart: Array<Maybe<AnnualCarbonEmissionsByFuelChartData>>;
    annualCarbonEmissionsNaturalGasChart: Array<Maybe<AnnualCarbonEmissionsByFuelChartData>>;
    annualEmissionSavingsByMeasureChart: Array<Maybe<AnnualEmissionSavingsByMeasureChartData>>;
    annualEmissionSavingsByMeasureTable: Array<Maybe<AnnualEmissionSavingsByMeasureTableRow>>;
    annualEndUse2050Chart?: Maybe<AnnualEndUseChart>;
    annualEnergyConsumptionCard: Array<Maybe<AnnualEnergyConsumptionRecommendationsCardData>>;
    averageMarginalAbatementCostByMeasureCategoryChart: Array<
        Maybe<AverageMarginalAbatementCostByMeasureCategoryChartData>
    >;
    cumulativeCarbonEmissionsCard: CarbonEmissionsCard;
    cumulativeEmissionSavingsCard: CumulativeEmissionSavingsCard;
    cumulativeEnergyConsumptionCard?: Maybe<EnergyConsumptionCard>;
    cumulativeInvestmentByDecarbonizationChart: Array<Maybe<CumulativeInvestmentByDecarbonizationChartData>>;
};

export type PrefilteredReports = {
    __typename?: "PrefilteredReports";
    prefilteredBaselineReport: PrefilteredBaselineReport;
    prefilteredRecommendationsReport: PrefilteredRecommendationsReport;
};

export type Property = {
    __typename?: "Property";
    annualCarbonEmissionIntensityCurrent?: Maybe<Scalars["Float"]>;
    annualCarbonPolicyCostIntensityCurrent?: Maybe<Scalars["Float"]>;
    annualEnergyUseIntensityCurrent?: Maybe<Scalars["Float"]>;
    annualUtilityCostIntensityCurrent?: Maybe<Scalars["Float"]>;
    averageMarginalAbatementCost?: Maybe<Scalars["Float"]>;
    buildingModels: Array<PropertyBuildingModel>;
    carbonEmissionReductionPotential?: Maybe<Scalars["Float"]>;
    fundName?: Maybe<Scalars["String"]>;
    grossFloorArea: Scalars["Float"];
    netPresentValueIntensity?: Maybe<Scalars["Float"]>;
    propertyName: Scalars["String"];
    propertyUid: Scalars["Uuid"];
};

export type PropertyBuildingModel = {
    __typename?: "PropertyBuildingModel";
    buildingArchetype: Scalars["String"];
    buildingModelUid: Scalars["Uuid"];
    buildingName: Scalars["String"];
    buildingStatus: BuildingStatus;
    dataCoverage: DataCoverage;
    location: Location;
    tags: Array<Scalars["String"]>;
};

export type Query = {
    __typename?: "Query";
    buildingFootprints: BuildingFootprints;
    buildingModel: BuildingModel;
    buildingModelCarbonReductionPlanReports: BuildingModelCarbonReductionPlanReports;
    buildingModelConstruction: BuildingModelConstruction;
    buildingModelHeader: BuildingModelHeader;
    buildingModelUtilityData: BuildingModelUtilityData;
    buildingModelsTable: Array<Maybe<BuildingModelsTableRow>>;
    carbonReductionPlanReports: CarbonReductionPlanReport;
    energyAggregation: EnergyAggregationByUtilityType;
    equipmentSurvey?: Maybe<EquipmentSurvey>;
    error?: Maybe<Scalars["String"]>;
    funds: Array<Fund>;
    internalAuthUser: InternalAuthUser;
    measure: MeasureReportViewData;
    prefilteredReports?: Maybe<PrefilteredReports>;
    properties: Array<Property>;
    user: User;
};

export type QueryBuildingFootprintsArgs = {
    address: Address;
    floorsAboveGrade: Scalars["Int"];
    grossFloorArea: Scalars["Float"];
};

export type QueryBuildingModelArgs = {
    buildingModelUid: Scalars["Uuid"];
};

export type QueryBuildingModelCarbonReductionPlanReportsArgs = {
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
};

export type QueryBuildingModelConstructionArgs = {
    buildingModelUid: Scalars["Uuid"];
};

export type QueryBuildingModelHeaderArgs = {
    buildingModelUid: Scalars["Uuid"];
};

export type QueryBuildingModelUtilityDataArgs = {
    buildingModelUid: Scalars["Uuid"];
};

export type QueryCarbonReductionPlanReportsArgs = {
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
};

export type QueryEnergyAggregationArgs = {
    buildingModelUid: Scalars["Uuid"];
};

export type QueryEquipmentSurveyArgs = {
    buildingModelUid: Scalars["Uuid"];
};

export type QueryInternalAuthUserArgs = {
    userId?: InputMaybe<Scalars["ID"]>;
};

export type QueryMeasureArgs = {
    carbonReductionMeasureUid: Scalars["Uuid"];
};

export type QueryPrefilteredReportsArgs = {
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
};

export type ReportFilter = {
    boolean_filters: Array<BooleanFilter>;
    data_coverage_filters: Array<DataCoverageEnum>;
    numeric_filters: Array<NumericFilter>;
    string_filters: Array<StringFilter>;
};

export type RooftopUnit = {
    __typename?: "RooftopUnit";
    rooftopUnitAverageInstallationYear?: Maybe<Scalars["Int"]>;
    rooftopUnitCoolingType?: Maybe<RooftopUnitCoolingType>;
    rooftopUnitExists: Scalars["Boolean"];
    rooftopUnitHeatingType?: Maybe<RooftopUnitHeatingType>;
    rooftopUnitSupplyAirRate?: Maybe<Scalars["Float"]>;
};

export enum RooftopUnitCoolingType {
    DirectExpansion = "direct_expansion",
}

export enum RooftopUnitHeatingType {
    ElectricResistance = "electric_resistance",
    Gas = "gas",
}

export type RooftopUnitInput = {
    rooftopUnitAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    rooftopUnitCoolingType?: InputMaybe<RooftopUnitCoolingType>;
    rooftopUnitExists: Scalars["Boolean"];
    rooftopUnitHeatingType?: InputMaybe<RooftopUnitHeatingType>;
    rooftopUnitSupplyAirRate?: InputMaybe<Scalars["Float"]>;
};

export type StringFilter = {
    condition: StringFilterCondition;
    field: StringFilterField;
    value: Array<Scalars["String"]>;
};

export enum StringFilterCondition {
    Contains = "contains",
    DoesNotContain = "does_not_contain",
    Equal = "equal",
    NotEqual = "not_equal",
    StartsWith = "starts_with",
}

export enum StringFilterField {
    BuildingArchetype = "building_archetype",
    BuildingName = "building_name",
    City = "city",
    Country = "country",
    EnergyType = "energy_type",
    FundName = "fund_name",
    PropertyName = "property_name",
    PropertyUid = "property_uid",
    StateProvince = "state_province",
    StreetAddress = "street_address",
    Tag = "tag",
}

export type SubmitUtilityDataResponse = {
    __typename?: "SubmitUtilityDataResponse";
    buildingModelRunUid?: Maybe<Scalars["Uuid"]>;
    error?: Maybe<Scalars["String"]>;
};

export type TerminalCooler = {
    __typename?: "TerminalCooler";
    terminalCoolerAverageInstallationYear?: Maybe<Scalars["Int"]>;
    terminalCoolerExists: Scalars["Boolean"];
    terminalCoolerSize?: Maybe<Scalars["Float"]>;
    terminalCoolerUnits?: Maybe<TerminalCoolerUnits>;
};

export type TerminalCoolerInput = {
    terminalCoolerAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    terminalCoolerExists: Scalars["Boolean"];
    terminalCoolerSize?: InputMaybe<Scalars["Float"]>;
    terminalCoolerUnits?: InputMaybe<TerminalCoolerUnits>;
};

export enum TerminalCoolerUnits {
    CoolingPtac = "cooling_ptac",
    SplitAirConditioner = "split_air_conditioner",
    WindowAirConditioner = "window_air_conditioner",
}

export type TerminalHeater = {
    __typename?: "TerminalHeater";
    terminalHeaterAverageInstallationYear?: Maybe<Scalars["Int"]>;
    terminalHeaterCoolerSize?: Maybe<Scalars["Float"]>;
    terminalHeaterExists: Scalars["Boolean"];
    terminalHeaterSize?: Maybe<Scalars["Float"]>;
    terminalHeaterUnits?: Maybe<TerminalHeaterUnits>;
};

export type TerminalHeaterInput = {
    terminalHeaterAverageInstallationYear?: InputMaybe<Scalars["Int"]>;
    terminalHeaterCoolerSize?: InputMaybe<Scalars["Float"]>;
    terminalHeaterExists: Scalars["Boolean"];
    terminalHeaterSize?: InputMaybe<Scalars["Float"]>;
    terminalHeaterUnits?: InputMaybe<TerminalHeaterUnits>;
};

export enum TerminalHeaterUnits {
    CondensingGasUnitHeater = "condensing_gas_unit_heater",
    ElectricBaseboard = "electric_baseboard",
    ElectricResistancePtac = "electric_resistance_ptac",
    ElectricUnitHeater = "electric_unit_heater",
    GasPtac = "gas_ptac",
    GasUnitHeater = "gas_unit_heater",
}

export type UpdateBuildingModelResponse = {
    __typename?: "UpdateBuildingModelResponse";
    buildingModelCarbonReductionPlanUid?: Maybe<Scalars["Uuid"]>;
    buildingModelRunUid?: Maybe<Scalars["Uuid"]>;
    buildingModelUid?: Maybe<Scalars["Uuid"]>;
    error?: Maybe<Scalars["String"]>;
};

export type User = {
    __typename?: "User";
    activeOrganization?: Maybe<Organization>;
    createdTimestamp: Scalars["Datetime"];
    email: Scalars["String"];
    isActive: Scalars["Boolean"];
    memberOrganizations: Array<Organization>;
    permissions: Array<Scalars["String"]>;
    roles: Array<Scalars["String"]>;
    userId: Scalars["String"];
};

export type UserInput = {
    activeOrganizationUid: Scalars["Uuid"];
};

export type UtilityData = {
    accountNumber?: InputMaybe<Scalars["String"]>;
    currency: Scalars["String"];
    endDate: Scalars["String"];
    energyConsumption: Scalars["Float"];
    energyConsumptionUnit: Scalars["String"];
    startDate: Scalars["String"];
    utilityCost?: InputMaybe<Scalars["Float"]>;
    utilityProvider?: InputMaybe<Scalars["String"]>;
    utilityType: UtilityTypes;
};

export enum UtilityTypes {
    Electricity = "electricity",
    NaturalGas = "natural_gas",
}

export type CreateCustomerAccountMutationVariables = Exact<{
    name: Scalars["String"];
    currencyCode: Scalars["String"];
}>;

export type CreateCustomerAccountMutation = { __typename?: "Mutation"; createCustomerAccount: string };

export type UpdateUserMutationVariables = Exact<{
    userInput: UserInput;
}>;

export type UpdateUserMutation = { __typename?: "Mutation"; user: boolean };

export type RemodelBuildingModelsMutationVariables = Exact<{
    buildingModelUids: Array<Scalars["Uuid"]> | Scalars["Uuid"];
}>;

export type RemodelBuildingModelsMutation = {
    __typename?: "Mutation";
    remodelBuildingModels: Array<{ __typename?: "PassFailResponse"; success?: boolean | null; error?: string | null }>;
};

export type BuildingBaselineAnnualCarbonEmissionsCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingBaselineAnnualCarbonEmissionsCardQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        annualCarbonEmissionsCard?: Array<{
            __typename?: "BuildingModelAnnualCarbonEmissionsCard";
            totalCarbonEmissions?: number | null;
            totalCarbonEmissionsElectricity?: number | null;
            totalCarbonEmissionsNaturalGas?: number | null;
            year?: number | null;
        }> | null;
    };
};

export type BuildingBaselineAnnualCarbonEmissionsChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingBaselineAnnualCarbonEmissionsChartQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        annualCarbonEmissionsChart?: Array<{
            __typename?: "BuildingModelAnnualCarbonEmissionsChart";
            totalCarbonEmissions?: number | null;
            year?: number | null;
        }> | null;
    };
};

export type BuildingBaselineAnnualCarbonEmissionsElectricityChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingBaselineAnnualCarbonEmissionsElectricityChartQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        annualCarbonEmissionsElectricityChart?: Array<{
            __typename?: "AnnualCarbonEmissionsByFuelChartData";
            year?: number | null;
            endUseCarbonEmissions: Array<{
                __typename?: "EndUseCarbonEmissions";
                endUse?: string | null;
                carbonEmissions?: number | null;
            } | null>;
        }> | null;
    };
};

export type BuildingBaselineAnnualCarbonEmissionsNaturalGasChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingBaselineAnnualCarbonEmissionsNaturalGasChartQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        annualCarbonEmissionsNaturalGasChart?: Array<{
            __typename?: "AnnualCarbonEmissionsByFuelChartData";
            year?: number | null;
            endUseCarbonEmissions: Array<{
                __typename?: "EndUseCarbonEmissions";
                endUse?: string | null;
                carbonEmissions?: number | null;
            } | null>;
        }> | null;
    };
};

export type BuildingBaselineAnnualEnergyConsumptionCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingBaselineAnnualEnergyConsumptionCardQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        annualEnergyConsumptionCard?: Array<{
            __typename?: "BuildingModelAnnualEnergyConsumptionCard";
            totalEnergyConsumption?: number | null;
            totalEnergyConsumptionElectricity?: number | null;
            totalEnergyConsumptionNaturalGas?: number | null;
            year?: number | null;
        }> | null;
    };
};

export type BuildingBaselineCumulativeCarbonEmissionsCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingBaselineCumulativeCarbonEmissionsCardQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        cumulativeCarbonEmissionsCard: {
            __typename?: "BuildingModelBaselineCumulativeCarbonEmissionsCard";
            totalCarbonEmissions?: number | null;
            totalCarbonEmissionsElectricity?: number | null;
            totalCarbonEmissionsNaturalGas?: number | null;
        };
    };
};

export type BuildingBaselineCumulativeEnergyConsumptionCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingBaselineCumulativeEnergyConsumptionCardQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        cumulativeEnergyConsumptionCard: {
            __typename?: "BuildingModelCumulativeEnergyConsumptionCard";
            totalEnergyConsumption?: number | null;
            totalEnergyConsumptionElectricity?: number | null;
            totalEnergyConsumptionNaturalGas?: number | null;
        };
    };
};

export type BuildingModelBaselineCurrentAnnualCarbonEmissionsCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingModelBaselineCurrentAnnualCarbonEmissionsCardQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        currentAnnualCarbonEmissionsCard: {
            __typename?: "BuildingModelCurrentAnnualCarbonEmissionsCard";
            totalEmissionIntensity?: number | null;
            totalCarbonEmissions?: number | null;
        };
    };
};

export type BuildingBaselineCurrentAnnualEndUseChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingBaselineCurrentAnnualEndUseChartQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        currentAnnualEndUseChart: {
            __typename?: "BuildingModelCurrentAnnualEndUseChart";
            carbonEmissions: Array<{
                __typename?: "EndUseValue";
                endUse?: string | null;
                fuelType?: string | null;
                value?: number | null;
            } | null>;
            energyConsumption: Array<{
                __typename?: "EndUseValue";
                endUse?: string | null;
                fuelType?: string | null;
                value?: number | null;
            } | null>;
            utilityCost: Array<{
                __typename?: "EndUseValue";
                endUse?: string | null;
                fuelType?: string | null;
                value?: number | null;
            } | null>;
        };
    };
};

export type BuildingBaselineCurrentAnnualEnergyConsumptionCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingBaselineCurrentAnnualEnergyConsumptionCardQuery = {
    __typename?: "Query";
    buildingModelCarbonReductionPlanReports: {
        __typename?: "BuildingModelCarbonReductionPlanReports";
        error?: string | null;
        currentAnnualEnergyConsumptionCard: {
            __typename?: "BuildingModelCurrentAnnualEnergyConsumptionCard";
            totalEnergyConsumption?: number | null;
            totalEnergyIntensity?: number | null;
        };
    };
};

export type AnnualCashFlowChartProjectReportQueryVariables = Exact<{
    carbonReductionMeasureUid: Scalars["Uuid"];
}>;

export type AnnualCashFlowChartProjectReportQuery = {
    __typename?: "Query";
    measure: {
        __typename?: "MeasureReportViewData";
        annualCashFlowChart?: {
            __typename?: "MeasureReportAnnualCashFlowChart";
            total: Array<{
                __typename?: "MeasureReportAnnualCashFlowChartTotal";
                carbonPolicyCostSavings: number;
                calendarYear: number;
                cashFlowAnnual: number;
                cashFlowCumulative: number;
                incrementalCost: number;
                revenue: number;
                utilityCostSavingsElectricity: number;
                utilityCostSavingsNaturalGas: number;
                likeForLikeCost: number;
                totalIncentives: number;
            }>;
            incremental: Array<{
                __typename?: "MeasureReportAnnualCashFlowChartIncremental";
                carbonPolicyCostSavings: number;
                calendarYear: number;
                cashFlowAnnual: number;
                cashFlowCumulative: number;
                incrementalCost: number;
                revenue: number;
                utilityCostSavingsElectricity: number;
                utilityCostSavingsNaturalGas: number;
                totalIncentives: number;
            }>;
        } | null;
    };
};

export type MeasureReportDecarbonizationForecastChartQueryVariables = Exact<{
    carbonReductionMeasureUid: Scalars["Uuid"];
}>;

export type MeasureReportDecarbonizationForecastChartQuery = {
    __typename?: "Query";
    measure: {
        __typename?: "MeasureReportViewData";
        decarbonizationForecastChart?: {
            __typename?: "MeasureReportDecarbonizationForecastChart";
            percentages?: {
                __typename?: "CarbonReductionMeasureDecarbonizationPercentages";
                currentMeasure: number;
                otherMeasureTypes: number;
                sameMeasureTypes: number;
            } | null;
            annualData?: Array<{
                __typename?: "MeasureReportDecarbonizationForecastAnnualData";
                calendarYear: number;
                carbonEmissionSavingsFromGrid: number;
                remainingCarbonEmissions: number;
                carbonReductionMeasureTypes: Array<{
                    __typename?: "MeasureReportDecarbonizationForecastChartDataMeasures";
                    carbonEmissionSavings: number;
                    carbonReductionMeasureType: string;
                    carbonReductionMeasureCategory: string;
                }>;
            }> | null;
        } | null;
    };
};

export type TotalCarbonEmissionsCardQueryVariables = Exact<{
    carbonReductionMeasureUid: Scalars["Uuid"];
}>;

export type TotalCarbonEmissionsCardQuery = {
    __typename?: "Query";
    measure: {
        __typename?: "MeasureReportViewData";
        totalCarbonEmissionsCard?: {
            __typename?: "MeasureReportTotalCarbonEmissionsCard";
            totalCarbonEmissionSavingsElectricity: number;
            totalCarbonEmissionSavingsNaturalGas: number;
            totalCarbonEmissionSavings: number;
        } | null;
    };
};

export type TotalEnergyConsumptionCardQueryVariables = Exact<{
    carbonReductionMeasureUid: Scalars["Uuid"];
}>;

export type TotalEnergyConsumptionCardQuery = {
    __typename?: "Query";
    measure: {
        __typename?: "MeasureReportViewData";
        totalEnergyConsumptionCard?: {
            __typename?: "MeasureReportTotalEnergyConsumptionCard";
            totalEnergyConsumptionSavings: number;
            totalEnergyConsumptionSavingsElectricity: number;
            totalEnergyConsumptionSavingsNaturalGas: number;
        } | null;
    };
};

export type BuildingRecommendationsAnnualCarbonEmissionsCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsAnnualCarbonEmissionsCardQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        annualCarbonEmissionsCard: Array<{
            __typename?: "BuildingModelAnnualCarbonEmissionsCardData";
            year?: number | null;
            totalCarbonEmissions?: number | null;
            totalCarbonEmissionSavings?: number | null;
            totalCarbonEmissionsPercentChange?: number | null;
            totalCarbonEmissionIntensity?: number | null;
            totalCarbonEmissionsNaturalGas?: number | null;
            totalCarbonEmissionsElectricity?: number | null;
        } | null>;
    };
};

export type BuildingModelRecommendationsAnnualCarbonEmissionsChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingModelRecommendationsAnnualCarbonEmissionsChartQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        annualCarbonEmissionsChart: Array<{
            __typename?: "BuildingModelAnnualCarbonEmissionsChartData";
            totalCarbonEmissionsBaseline?: number | null;
            totalCarbonEmissionsRecommendations?: number | null;
            year?: number | null;
        } | null>;
    };
};

export type BuildingRecommendationsAnnualCarbonEmissionsElectricityChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsAnnualCarbonEmissionsElectricityChartQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        annualCarbonEmissionsElectricityChart: Array<{
            __typename?: "AnnualCarbonEmissionsByFuelChartData";
            year?: number | null;
            endUseCarbonEmissions: Array<{
                __typename?: "EndUseCarbonEmissions";
                endUse?: string | null;
                carbonEmissions?: number | null;
            } | null>;
        } | null>;
    };
};

export type BuildingRecommendationsAnnualCarbonEmissionsNaturalGasChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsAnnualCarbonEmissionsNaturalGasChartQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        annualCarbonEmissionsNaturalGasChart: Array<{
            __typename?: "AnnualCarbonEmissionsByFuelChartData";
            year?: number | null;
            endUseCarbonEmissions: Array<{
                __typename?: "EndUseCarbonEmissions";
                endUse?: string | null;
                carbonEmissions?: number | null;
            } | null>;
        } | null>;
    };
};

export type BuildingModelRecommendationsAnnualEmissionSavingsByMeasureChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingModelRecommendationsAnnualEmissionSavingsByMeasureChartQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        annualEmissionSavingsByMeasureChart: Array<{
            __typename?: "AnnualEmissionSavingsByMeasureChartData";
            carbonEmissionSavingsFromGrid?: number | null;
            remainingCarbonEmissions?: number | null;
            year?: number | null;
            carbonReductionMeasureCategories: Array<{
                __typename?: "AnnualEmissionSavingsByMeasureCategory";
                carbonReductionMeasureCategory?: string | null;
                totalCarbonEmissionSavings?: number | null;
            } | null>;
        } | null>;
    };
};

export type BuildingModelRecommendationsAnnualEmissionSavingsByMeasureTableQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingModelRecommendationsAnnualEmissionSavingsByMeasureTableQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        annualEmissionSavingsByMeasureTable: Array<{
            __typename?: "BuildingModelAnnualEmissionSavingsByMeasureTableRow";
            annualCarbonEmissionSavings?: number | null;
            annualEnergyConsumptionSavings?: number | null;
            annualEnergyCostSavings?: number | null;
            carbonReductionMeasureCategory?: string | null;
            carbonReductionMeasureType?: string | null;
            impactPercentage?: number | null;
            incrementalCost?: number | null;
            likeForLikeCost?: number | null;
            yearApplied?: number | null;
        } | null>;
    };
};

export type BuildingRecommendationsAnnualEndUse2050ChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsAnnualEndUse2050ChartQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        annualEndUse2050Chart?: {
            __typename?: "AnnualEndUseChart";
            carbonEmissions: Array<{
                __typename?: "EndUseValue";
                endUse?: string | null;
                fuelType?: string | null;
                value?: number | null;
            } | null>;
            energyConsumption: Array<{
                __typename?: "EndUseValue";
                endUse?: string | null;
                fuelType?: string | null;
                value?: number | null;
            } | null>;
            utilityCost: Array<{
                __typename?: "EndUseValue";
                endUse?: string | null;
                fuelType?: string | null;
                value?: number | null;
            } | null>;
        } | null;
    };
};

export type BuildingRecommendationsAnnualEnergyConsumptionCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsAnnualEnergyConsumptionCardQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        annualEnergyConsumptionCard: Array<{
            __typename?: "BuildingModelAnnualEnergyConsumptionCardData";
            totalEnergyConsumption?: number | null;
            totalEnergyConsumptionSavings?: number | null;
            totalEnergyConsumptionPercentChange?: number | null;
            totalEnergyIntensity?: number | null;
            totalEnergyConsumptionNaturalGas?: number | null;
            totalEnergyConsumptionElectricity?: number | null;
            year?: number | null;
        } | null>;
    };
};

export type BuildingRecommendationsAverageMarginalAbatementCostByMeasureCategoryChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsAverageMarginalAbatementCostByMeasureCategoryChartQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        averageMarginalAbatementCostByMeasureCategoryChart: Array<{
            __typename?: "AverageMarginalAbatementCostByMeasureCategoryChartData";
            carbonReductionMeasureCategory?: string | null;
            averageMarginalAbatementCost?: number | null;
            totalLifetimeCarbonEmissionSavings?: number | null;
        } | null>;
    };
};

export type BuildingRecommendationsCumulativeCarbonEmissionsCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsCumulativeCarbonEmissionsCardQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        cumulativeCarbonEmissionsCard: {
            __typename?: "BuildingModelCumulativeCarbonEmissionsCard";
            totalCarbonEmissions?: number | null;
            totalCarbonEmissionSavings?: number | null;
            totalCarbonEmissionsPercentChange?: number | null;
            totalCarbonEmissionIntensity?: number | null;
            totalCarbonEmissionsNaturalGas?: number | null;
            totalCarbonEmissionsElectricity?: number | null;
        };
    };
};

export type BuildingRecommendationsCumulativeEmissionSavingsCardRecommendationsReportQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsCumulativeEmissionSavingsCardRecommendationsReportQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        cumulativeEmissionSavingsCard: {
            __typename?: "CumulativeEmissionSavingsCard";
            totalCarbonEmissionSavings?: number | null;
            totalCarbonEmissionSavingsFromMeasures?: number | null;
            totalCarbonEmissionSavingsFromGrid?: number | null;
        };
    };
};

export type BuildingRecommendationsCumulativeEnergyConsumptionCardQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsCumulativeEnergyConsumptionCardQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        cumulativeEnergyConsumptionCard: {
            __typename?: "BuildingModelEnergyConsumptionCard";
            totalEnergyConsumption?: number | null;
            totalEnergyConsumptionSavings?: number | null;
            totalEnergyConsumptionPercentChange?: number | null;
            totalEnergyIntensity?: number | null;
            totalEnergyConsumptionNaturalGas?: number | null;
            totalEnergyConsumptionElectricity?: number | null;
        };
    };
};

export type BuildingRecommendationsCumulativeInvestmentByDecarbonizationChartQueryVariables = Exact<{
    buildingModelCarbonReductionPlanId: Scalars["Uuid"];
}>;

export type BuildingRecommendationsCumulativeInvestmentByDecarbonizationChartQuery = {
    __typename?: "Query";
    carbonReductionPlanReports: {
        __typename?: "CarbonReductionPlanReport";
        error?: string | null;
        cumulativeInvestmentByDecarbonizationChart: Array<{
            __typename?: "CumulativeInvestmentByDecarbonizationChartData";
            totalMeasureCost?: number | null;
            decarbonizationPercentage?: number | null;
        } | null>;
    };
};

export type BuildingModelConstructionQueryVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
}>;

export type BuildingModelConstructionQuery = {
    __typename?: "Query";
    buildingModelConstruction: {
        __typename?: "BuildingModelConstruction";
        error?: string | null;
        buildingArchetype?: string | null;
        yearBuiltOriginal?: number | null;
        grossFloorArea?: number | null;
        floorsAboveGrade?: number | null;
        ledInstalledRatio?: number | null;
        buildingHeight?: number | null;
        buildingUid?: string | null;
        footprintArea?: number | null;
        wallRValue?: number | null;
        roofArea?: number | null;
        availableRoofAreaRatio?: number | null;
        roofRValue?: number | null;
        roofInstallationYear?: number | null;
        windowSolarHeatGainCoefficient?: number | null;
        windowToWallRatio?: number | null;
        windowRValue?: number | null;
        windowInstallationYear?: number | null;
        coolingMultiplier?: number | null;
        fansMultiplier?: number | null;
        heatingMultiplier?: number | null;
        lightingMultiplier?: number | null;
        plugLoadMultiplier?: number | null;
        processMultiplier?: number | null;
        pumpsMultiplier?: number | null;
        domesticHotWaterMultiplier?: number | null;
        ventilationRateMultiplier?: number | null;
        defaultDiscountRate?: number | null;
        defaultGridIntensityScheduleScenario?: string | null;
        defaultWeightEmissionSavings?: number | null;
        defaultWeightNetPresentValue?: number | null;
        defaultUtilityInflationRate?: number | null;
        defaultElectricityUtilityRate?: number | null;
        defaultNaturalGasUtilityRate?: number | null;
        defaultSteamUtilityRate?: number | null;
        assumedHeatingEnergyType?: string | null;
        assumedCoolingEnergyType?: string | null;
        assumedDhwEnergyType?: string | null;
        defaultLandlordShareCost?: number | null;
        defaultLandlordShareElectricity?: number | null;
        defaultLandlordShareNaturalGas?: number | null;
        defaultLandlordShareSteam?: number | null;
        assumedGrossAssetValue?: number | null;
        customerBuildingIdentifier?: string | null;
        notes?: string | null;
        leasingStructure?: string | null;
        assumedExitCapRate?: number | null;
        assumedExitYear?: number | null;
        location?: {
            __typename?: "Location";
            streetAddress?: string | null;
            city?: string | null;
            stateProvince?: string | null;
            postalZipCode?: string | null;
            country?: string | null;
            latitude?: number | null;
            longitude?: number | null;
            climateZone?: string | null;
        } | null;
        buildingFootprint?: {
            __typename?: "FootprintPolygon";
            type: FeatureType;
            geometry: {
                __typename?: "FootprintPolygonGeometry";
                type: GeometryType;
                coordinates: Array<Array<[number, number]>>;
            };
            properties: {
                __typename?: "FootprintPolygonProperties";
                latitude: number;
                longitude: number;
                buildingUid?: string | null;
            };
        } | null;
    };
};

export type CreateCustomPlanFromPlanMutationVariables = Exact<{
    carbonReductionPlanUid: Scalars["Uuid"];
    planName: Scalars["String"];
}>;

export type CreateCustomPlanFromPlanMutation = { __typename?: "Mutation"; createCustomPlanFromPlan: string };

export type DeleteCustomCarbonReductionPlanMutationVariables = Exact<{
    carbonReductionPlanUid: Scalars["Uuid"];
}>;

export type DeleteCustomCarbonReductionPlanMutation = {
    __typename?: "Mutation";
    deleteCustomCarbonReductionPlan: string;
};

export type PublishPlanMutationVariables = Exact<{
    id: Scalars["Uuid"];
}>;

export type PublishPlanMutation = { __typename?: "Mutation"; publishPlan: string };

export type ReportPlanMutationVariables = Exact<{
    id: Scalars["Uuid"];
}>;

export type ReportPlanMutation = { __typename?: "Mutation"; reportPlan: string };

export type UnpublishPlanMutationVariables = Exact<{
    id: Scalars["Uuid"];
}>;

export type UnpublishPlanMutation = { __typename?: "Mutation"; unpublishPlan: string };

export type UnreportPlanMutationVariables = Exact<{
    id: Scalars["Uuid"];
}>;

export type UnreportPlanMutation = { __typename?: "Mutation"; unreportPlan: string };

export type UpdateCustomPlanMeasuresMutationVariables = Exact<{
    id: Scalars["Uuid"];
    measures: Array<InputMaybe<CarbonReductionMeasureInput>> | InputMaybe<CarbonReductionMeasureInput>;
}>;

export type UpdateCustomPlanMeasuresMutation = { __typename?: "Mutation"; updateCustomPlanMeasures: string };

export type UpdateCustomPlanNameMutationVariables = Exact<{
    id: Scalars["Uuid"];
    name: Scalars["String"];
}>;

export type UpdateCustomPlanNameMutation = { __typename?: "Mutation"; updateCustomPlanName: string };

export type DeleteEquipmentSurveyMutationVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
}>;

export type DeleteEquipmentSurveyMutation = {
    __typename?: "Mutation";
    deleteEquipmentSurvey: {
        __typename?: "UpdateBuildingModelResponse";
        error?: string | null;
        buildingModelRunUid?: string | null;
        buildingModelUid?: string | null;
    };
};

export type EquipmentSurveyQueryVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
}>;

export type EquipmentSurveyQuery = {
    __typename?: "Query";
    equipmentSurvey?: {
        __typename?: "EquipmentSurvey";
        error?: string | null;
        airHandlingEquipment?: {
            __typename?: "AirHandlingEquipment";
            airHandlingEquipmentExists: boolean;
            airHandlingEquipmentType?: AirHandlingEquipmentType | null;
            airHandlingEquipmentHeatingType?: AirHandlingEquipmentHeatingType | null;
            airHandlingEquipmentCoolingType?: AirHandlingEquipmentCoolingType | null;
            airHandlingEquipmentSupplyAirRate?: number | null;
            airHandlingEquipmentAverageInstallationYear?: number | null;
        } | null;
        centralPlantCooler?: {
            __typename?: "CentralPlantCooler";
            centralPlantCoolerExists: boolean;
            centralPlantCoolerType?: CentralPlantCoolerType | null;
            centralPlantCoolerTerminalUnits?: CentralPlantCoolerTerminalUnits | null;
            centralPlantCoolerSize?: number | null;
            centralPlantCoolerAverageInstallationYear?: number | null;
        } | null;
        centralPlantHeater?: {
            __typename?: "CentralPlantHeater";
            centralPlantHeaterExists: boolean;
            centralPlantHeaterType?: CentralPlantHeaterType | null;
            centralPlantHeaterTerminalUnits?: CentralPlantHeaterTerminalUnits | null;
            centralPlantHeaterSize?: number | null;
            centralPlantHeaterAverageInstallationYear?: number | null;
        } | null;
        centralPlantHeatPump?: {
            __typename?: "CentralPlantHeatPump";
            centralPlantHeatPumpExists: boolean;
            centralPlantHeatPumpType?: CentralPlantHeatPumpType | null;
            centralPlantHeatPumpSize?: number | null;
            centralPlantHeatPumpAverageInstallationYear?: number | null;
        } | null;
        genericHVACEquipment: Array<{
            __typename?: "GenericHVACEquipment";
            name: string;
            size: number;
            coefficientOfPerformance: number;
            endUse: string;
            fuel: string;
            installationYear: number;
            lifeSpan: number;
            loadRatio: number;
            sizeUnits: string;
        }>;
        domesticHotWaterHeater?: {
            __typename?: "DomesticHotWaterHeater";
            domesticHotWaterHeaterExists: boolean;
            domesticHotWaterHeaterType?: DomesticHotWaterHeaterType | null;
            domesticHotWaterHeaterSize?: number | null;
            domesticHotWaterHeaterAverageInstallationYear?: number | null;
            domesticHotWaterHeaterCentralDistribution: boolean;
        } | null;
        heatPump?: {
            __typename?: "HeatPump";
            heatPumpExists: boolean;
            heatPumpType?: HeatPumpType | null;
            heatPumpSize?: number | null;
            heatPumpInstallationYear?: number | null;
        } | null;
        otherEquipment?: {
            __typename?: "OtherEquipment";
            clothesDryersExists: boolean;
            clothesDryersType?: ClothesDryersType | null;
            clothesDryersEnergyDensity?: number | null;
            clothesDryersAverageInstallationYear?: number | null;
            clothesWashersExists: boolean;
            clothesWashersEnergyDensity?: number | null;
            clothesWashersAverageInstallationYear?: number | null;
            escalatorExists: boolean;
            escalatorQuantity?: number | null;
            escalatorInstallationYear?: number | null;
            elevatorsExists: boolean;
            elevatorsQuantity?: number | null;
            elevatorsAverageInstallationYear?: number | null;
            rooftopPhotovoltaicsExists: boolean;
            rooftopPhotovoltaicsSize?: number | null;
            rooftopPhotovoltaicsAverageInstallationYear?: number | null;
        } | null;
        rooftopUnit?: {
            __typename?: "RooftopUnit";
            rooftopUnitExists: boolean;
            rooftopUnitHeatingType?: RooftopUnitHeatingType | null;
            rooftopUnitCoolingType?: RooftopUnitCoolingType | null;
            rooftopUnitSupplyAirRate?: number | null;
            rooftopUnitAverageInstallationYear?: number | null;
        } | null;
        terminalCooler?: {
            __typename?: "TerminalCooler";
            terminalCoolerExists: boolean;
            terminalCoolerUnits?: TerminalCoolerUnits | null;
            terminalCoolerSize?: number | null;
            terminalCoolerAverageInstallationYear?: number | null;
        } | null;
        terminalHeater?: {
            __typename?: "TerminalHeater";
            terminalHeaterCoolerSize?: number | null;
            terminalHeaterExists: boolean;
            terminalHeaterUnits?: TerminalHeaterUnits | null;
            terminalHeaterSize?: number | null;
            terminalHeaterAverageInstallationYear?: number | null;
        } | null;
    } | null;
};

export type SubmitEquipmentSurveyMutationVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
    equipmentSurvey: EquipmentSurveyInput;
}>;

export type SubmitEquipmentSurveyMutation = {
    __typename?: "Mutation";
    submitEquipmentSurvey: { __typename?: "PassFailResponse"; error?: string | null; success?: boolean | null };
};

export type FundsQueryVariables = Exact<{ [key: string]: never }>;

export type FundsQuery = {
    __typename?: "Query";
    funds: Array<{
        __typename?: "Fund";
        annualCarbonEmissionIntensityCurrent?: number | null;
        annualCarbonPolicyCostIntensityCurrent?: number | null;
        annualEnergyUseIntensityCurrent?: number | null;
        annualUtilityCostIntensityCurrent?: number | null;
        averageMarginalAbatementCost?: number | null;
        carbonEmissionReductionPotential?: number | null;
        fundId: number;
        fundName: string;
        grossFloorArea: number;
        netPresentValueIntensity?: number | null;
        properties: Array<{
            __typename?: "FundProperty";
            propertyUid: string;
            buildingModels: Array<{
                __typename?: "FundPropertyBuildingModel";
                buildingModelUid: string;
                tags: Array<string>;
                dataCoverage: {
                    __typename?: "DataCoverage";
                    dataCoverage: DataCoverageEnum;
                    energyType: EnergyTypeEnum;
                    energyTypeFromEquipmentData?: EnergyTypeEnum | null;
                    energyTypeFromUtilityData?: EnergyTypeEnum | null;
                    equipmentDataHasSizeAndYear: boolean;
                    equipmentDataUploaded: boolean;
                    modellingStatus: ModellingStatus;
                    utilityDataUploaded: boolean;
                };
            }>;
        }>;
    }>;
};

export type SetPropertyFundMutationVariables = Exact<{
    propertyUids: Array<Scalars["Uuid"]> | Scalars["Uuid"];
    fundName?: InputMaybe<Scalars["String"]>;
}>;

export type SetPropertyFundMutation = {
    __typename?: "Mutation";
    setPropertyFund: { __typename?: "PassFailResponse"; error?: string | null; success?: boolean | null };
};

export type CreateReportFiltersetMutationVariables = Exact<{
    reportFilter: ReportFilter;
}>;

export type CreateReportFiltersetMutation = { __typename?: "Mutation"; createReportFilterset?: string | null };

export type PropertiesQueryVariables = Exact<{ [key: string]: never }>;

export type PropertiesQuery = {
    __typename?: "Query";
    properties: Array<{
        __typename?: "Property";
        annualCarbonEmissionIntensityCurrent?: number | null;
        annualCarbonPolicyCostIntensityCurrent?: number | null;
        annualEnergyUseIntensityCurrent?: number | null;
        annualUtilityCostIntensityCurrent?: number | null;
        averageMarginalAbatementCost?: number | null;
        carbonEmissionReductionPotential?: number | null;
        fundName?: string | null;
        grossFloorArea: number;
        netPresentValueIntensity?: number | null;
        propertyName: string;
        propertyUid: string;
        buildingModels: Array<{
            __typename?: "PropertyBuildingModel";
            buildingArchetype: string;
            buildingModelUid: string;
            buildingName: string;
            tags: Array<string>;
            dataCoverage: {
                __typename?: "DataCoverage";
                dataCoverage: DataCoverageEnum;
                energyType: EnergyTypeEnum;
                energyTypeFromEquipmentData?: EnergyTypeEnum | null;
                energyTypeFromUtilityData?: EnergyTypeEnum | null;
                equipmentDataHasSizeAndYear: boolean;
                equipmentDataUploaded: boolean;
                modellingStatus: ModellingStatus;
                utilityDataUploaded: boolean;
            };
            location: {
                __typename?: "Location";
                streetAddress?: string | null;
                city?: string | null;
                stateProvince?: string | null;
                postalZipCode?: string | null;
                country?: string | null;
                latitude?: number | null;
                longitude?: number | null;
                climateZone?: string | null;
            };
        }>;
    }>;
};

export type SetBuildingModelPropertyMutationVariables = Exact<{
    buildingModelUids: Array<Scalars["Uuid"]> | Scalars["Uuid"];
    propertyName?: InputMaybe<Scalars["String"]>;
}>;

export type SetBuildingModelPropertyMutation = {
    __typename?: "Mutation";
    setBuildingModelProperty: { __typename?: "PassFailResponse"; error?: string | null; success?: boolean | null };
};

export type AnnualCarbonEmissionsCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type AnnualCarbonEmissionsCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            annualCarbonEmissionsCard: {
                __typename?: "AnnualCarbonEmissionsCard";
                error?: string | null;
                data: Array<{
                    __typename?: "AnnualCarbonEmissionsBaselineCardData";
                    totalCarbonEmissions?: number | null;
                    totalCarbonEmissionsElectricity?: number | null;
                    totalCarbonEmissionsNaturalGas?: number | null;
                    year?: number | null;
                } | null>;
            };
        };
    } | null;
};

export type AnnualCarbonEmissionsChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type AnnualCarbonEmissionsChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            annualCarbonEmissionsChart: {
                __typename?: "AnnualCarbonEmissionsChart";
                error?: string | null;
                data: Array<{
                    __typename?: "AnnualCarbonEmissionsBaselineChartData";
                    totalCarbonEmissions?: number | null;
                    year?: number | null;
                } | null>;
            };
        };
    } | null;
};

export type QueryBaselineAnnualCarbonEmissionsElectricityChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type QueryBaselineAnnualCarbonEmissionsElectricityChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            annualCarbonEmissionsElectricityChart: Array<{
                __typename?: "AnnualCarbonEmissionsByFuelChartData";
                year?: number | null;
                endUseCarbonEmissions: Array<{
                    __typename?: "EndUseCarbonEmissions";
                    endUse?: string | null;
                    carbonEmissions?: number | null;
                } | null>;
            } | null>;
        };
    } | null;
};

export type QueryBaselineAnnualCarbonEmissionsNaturalGasChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type QueryBaselineAnnualCarbonEmissionsNaturalGasChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            annualCarbonEmissionsNaturalGasChart: Array<{
                __typename?: "AnnualCarbonEmissionsByFuelChartData";
                year?: number | null;
                endUseCarbonEmissions: Array<{
                    __typename?: "EndUseCarbonEmissions";
                    endUse?: string | null;
                    carbonEmissions?: number | null;
                } | null>;
            } | null>;
        };
    } | null;
};

export type AnnualEnergyConsumptionCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type AnnualEnergyConsumptionCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            annualEnergyConsumptionCard: {
                __typename?: "AnnualEnergyConsumptionCard";
                error?: string | null;
                data: Array<{
                    __typename?: "AnnualEnergyConsumptionCardData";
                    totalEnergyConsumption?: number | null;
                    totalEnergyConsumptionElectricity?: number | null;
                    totalEnergyConsumptionNaturalGas?: number | null;
                    year?: number | null;
                } | null>;
            };
        };
    } | null;
};

export type BuildingBarChartAndMapQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type BuildingBarChartAndMapQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            buildingBarChartAndMap: Array<{
                __typename?: "BuildingBarChartAndMap";
                annualCarbonEmissionIntensityCurrent: number;
                annualCarbonEmissionsCurrent: number;
                annualEnergyConsumptionCurrent: number;
                annualEnergyUseIntensityCurrent: number;
                buildingModelUid: string;
                location: {
                    __typename?: "Location";
                    streetAddress?: string | null;
                    city?: string | null;
                    stateProvince?: string | null;
                    postalZipCode?: string | null;
                    country?: string | null;
                    latitude?: number | null;
                    longitude?: number | null;
                    climateZone?: string | null;
                };
            }>;
        };
    } | null;
};

export type BuildingBarChartAndMapByPropertyQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type BuildingBarChartAndMapByPropertyQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            buildingBarChartAndMapByProperty: Array<{
                __typename?: "BuildingBarChartAndMapByProperty";
                averageAnnualCarbonEmissionIntensityCurrent: number;
                averageAnnualEnergyUseIntensityCurrent: number;
                latitude: number;
                longitude: number;
                propertyName: string;
                totalAnnualCarbonEmissionsCurrent: number;
                totalAnnualEnergyConsumptionCurrent: number;
            }>;
        };
    } | null;
};

export type BuildingCountQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type BuildingCountQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: { __typename?: "PrefilteredBaselineReport"; buildingCount: number };
    } | null;
};

export type CumulativeCarbonEmissionsCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type CumulativeCarbonEmissionsCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            cumulativeCarbonEmissionsCard: {
                __typename?: "CumulativeCarbonEmissionsCard";
                error?: string | null;
                totalCarbonEmissions?: number | null;
                totalCarbonEmissionsElectricity?: number | null;
                totalCarbonEmissionsNaturalGas?: number | null;
            };
        };
    } | null;
};

export type CumulativeEnergyConsumptionCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type CumulativeEnergyConsumptionCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            cumulativeEnergyConsumptionCard: {
                __typename?: "CumulativeEnergyConsumptionCard";
                error?: string | null;
                totalEnergyConsumption?: number | null;
                totalEnergyConsumptionElectricity?: number | null;
                totalEnergyConsumptionNaturalGas?: number | null;
            };
        };
    } | null;
};

export type CurrentAnnualCarbonEmissionsCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type CurrentAnnualCarbonEmissionsCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            currentAnnualCarbonEmissionsCard: {
                __typename?: "CurrentAnnualCarbonEmissionsCard";
                error?: string | null;
                averageEmissionsIntensity?: number | null;
                totalCarbonEmissions?: number | null;
            };
        };
    } | null;
};

export type CurrentAnnualEndUseChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type CurrentAnnualEndUseChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            currentAnnualEndUseChart: {
                __typename?: "AnnualEndUseChart";
                error?: string | null;
                carbonEmissions: Array<{
                    __typename?: "EndUseValue";
                    endUse?: string | null;
                    fuelType?: string | null;
                    value?: number | null;
                } | null>;
                energyConsumption: Array<{
                    __typename?: "EndUseValue";
                    endUse?: string | null;
                    fuelType?: string | null;
                    value?: number | null;
                } | null>;
                utilityCost: Array<{
                    __typename?: "EndUseValue";
                    endUse?: string | null;
                    fuelType?: string | null;
                    value?: number | null;
                } | null>;
            };
        };
    } | null;
};

export type CurrentAnnualEnergyConsumptionCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type CurrentAnnualEnergyConsumptionCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            currentAnnualEnergyConsumptionCard: {
                __typename?: "CurrentAnnualEnergyConsumptionCard";
                error?: string | null;
                averageEnergyIntensity: number;
                totalEnergyConsumption: number;
            };
        };
    } | null;
};

export type CurrentAnnualEnergyCostCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type CurrentAnnualEnergyCostCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredBaselineReport: {
            __typename?: "PrefilteredBaselineReport";
            currentAnnualEnergyCostCard: {
                __typename?: "CurrentAnnualEnergyCostCard";
                totalEnergyCost: number;
                landlordEnergyCost: number;
                tenantEnergyCost: number;
            };
        };
    } | null;
};

export type RecommendationsAnnualCarbonEmissionsCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type RecommendationsAnnualCarbonEmissionsCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            annualCarbonEmissionsCard: Array<{
                __typename?: "AnnualCarbonEmissionsRecommendationsCardData";
                year?: number | null;
                totalCarbonEmissions?: number | null;
                totalCarbonEmissionSavings?: number | null;
                totalCarbonEmissionsPercentChange?: number | null;
                averageCarbonEmissionIntensity?: number | null;
                totalCarbonEmissionsNaturalGas?: number | null;
                totalCarbonEmissionsElectricity?: number | null;
            } | null>;
        };
    } | null;
};

export type RecommendationsAnnualCarbonEmissionsChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type RecommendationsAnnualCarbonEmissionsChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            annualCarbonEmissionsChart: Array<{
                __typename?: "AnnualCarbonEmissionsRecommendationsChartData";
                totalCarbonEmissionsBaseline?: number | null;
                totalCarbonEmissionsGoal?: number | null;
                year?: number | null;
            } | null>;
        };
    } | null;
};

export type QueryAnnualCarbonEmissionsElectricityChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type QueryAnnualCarbonEmissionsElectricityChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            annualCarbonEmissionsElectricityChart: Array<{
                __typename?: "AnnualCarbonEmissionsByFuelChartData";
                year?: number | null;
                endUseCarbonEmissions: Array<{
                    __typename?: "EndUseCarbonEmissions";
                    endUse?: string | null;
                    carbonEmissions?: number | null;
                } | null>;
            } | null>;
        };
    } | null;
};

export type AnnualCarbonEmissionsNaturalGasChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type AnnualCarbonEmissionsNaturalGasChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            annualCarbonEmissionsNaturalGasChart: Array<{
                __typename?: "AnnualCarbonEmissionsByFuelChartData";
                year?: number | null;
                endUseCarbonEmissions: Array<{
                    __typename?: "EndUseCarbonEmissions";
                    endUse?: string | null;
                    carbonEmissions?: number | null;
                } | null>;
            } | null>;
        };
    } | null;
};

export type AnnualEmissionSavingsByMeasureChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type AnnualEmissionSavingsByMeasureChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            annualEmissionSavingsByMeasureChart: Array<{
                __typename?: "AnnualEmissionSavingsByMeasureChartData";
                carbonEmissionSavingsFromGrid?: number | null;
                remainingCarbonEmissions?: number | null;
                year?: number | null;
                carbonReductionMeasureCategories: Array<{
                    __typename?: "AnnualEmissionSavingsByMeasureCategory";
                    carbonReductionMeasureCategory?: string | null;
                    totalCarbonEmissionSavings?: number | null;
                } | null>;
            } | null>;
        };
    } | null;
};

export type AnnualEmissionSavingsByMeasureTableQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type AnnualEmissionSavingsByMeasureTableQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            annualEmissionSavingsByMeasureTable: Array<{
                __typename?: "AnnualEmissionSavingsByMeasureTableRow";
                impactPercentage?: number | null;
                carbonReductionMeasureCategory?: string | null;
                measureCount?: number | null;
                totalAnnualCarbonEmissionSavings?: number | null;
                totalAnnualEnergyConsumptionSavings?: number | null;
                totalAnnualEnergyCostSavings?: number | null;
                totalMeasureCost?: number | null;
            } | null>;
        };
    } | null;
};

export type QueryAnnualEndUse2050ChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type QueryAnnualEndUse2050ChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            annualEndUse2050Chart?: {
                __typename?: "AnnualEndUseChart";
                carbonEmissions: Array<{
                    __typename?: "EndUseValue";
                    endUse?: string | null;
                    fuelType?: string | null;
                    value?: number | null;
                } | null>;
                energyConsumption: Array<{
                    __typename?: "EndUseValue";
                    endUse?: string | null;
                    fuelType?: string | null;
                    value?: number | null;
                } | null>;
                utilityCost: Array<{
                    __typename?: "EndUseValue";
                    endUse?: string | null;
                    fuelType?: string | null;
                    value?: number | null;
                } | null>;
            } | null;
        };
    } | null;
};

export type RecommendationsAnnualEnergyConsumptionCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type RecommendationsAnnualEnergyConsumptionCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            annualEnergyConsumptionCard: Array<{
                __typename?: "AnnualEnergyConsumptionRecommendationsCardData";
                year?: number | null;
                totalEnergyConsumption?: number | null;
                totalEnergyConsumptionSavings?: number | null;
                totalEnergyConsumptionPercentChange?: number | null;
                averageEnergyIntensity?: number | null;
                totalEnergyConsumptionNaturalGas?: number | null;
                totalEnergyConsumptionElectricity?: number | null;
            } | null>;
        };
    } | null;
};

export type AverageMarginalAbatementCostByMeasureCategoryChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type AverageMarginalAbatementCostByMeasureCategoryChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            averageMarginalAbatementCostByMeasureCategoryChart: Array<{
                __typename?: "AverageMarginalAbatementCostByMeasureCategoryChartData";
                carbonReductionMeasureCategory?: string | null;
                averageMarginalAbatementCost?: number | null;
                totalLifetimeCarbonEmissionSavings?: number | null;
            } | null>;
        };
    } | null;
};

export type RecommendationsCumulativeCarbonEmissionsCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type RecommendationsCumulativeCarbonEmissionsCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            cumulativeCarbonEmissionsCard: {
                __typename?: "CarbonEmissionsCard";
                totalCarbonEmissions?: number | null;
                totalCarbonEmissionSavings?: number | null;
                totalCarbonEmissionsPercentChange?: number | null;
                averageCarbonEmissionIntensity?: number | null;
                totalCarbonEmissionsNaturalGas?: number | null;
                totalCarbonEmissionsElectricity?: number | null;
            };
        };
    } | null;
};

export type CumulativeEmissionSavingsCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type CumulativeEmissionSavingsCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            cumulativeEmissionSavingsCard: {
                __typename?: "CumulativeEmissionSavingsCard";
                totalCarbonEmissionSavings?: number | null;
                totalCarbonEmissionSavingsFromMeasures?: number | null;
                totalCarbonEmissionSavingsFromGrid?: number | null;
            };
        };
    } | null;
};

export type CumulativeInvestmentByDecarbonizationChartQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type CumulativeInvestmentByDecarbonizationChartQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            cumulativeInvestmentByDecarbonizationChart: Array<{
                __typename?: "CumulativeInvestmentByDecarbonizationChartData";
                totalMeasureCost?: number | null;
                decarbonizationPercentage?: number | null;
            } | null>;
        };
    } | null;
};

export type RecommendationsCumulativeEnergyConsumptionCardQueryVariables = Exact<{
    reportFiltersetUid?: InputMaybe<Scalars["Uuid"]>;
}>;

export type RecommendationsCumulativeEnergyConsumptionCardQuery = {
    __typename?: "Query";
    prefilteredReports?: {
        __typename?: "PrefilteredReports";
        prefilteredRecommendationsReport: {
            __typename?: "PrefilteredRecommendationsReport";
            cumulativeEnergyConsumptionCard?: {
                __typename?: "EnergyConsumptionCard";
                totalEnergyConsumption?: number | null;
                totalEnergyConsumptionSavings?: number | null;
                totalEnergyConsumptionPercentChange?: number | null;
                averageEnergyIntensity?: number | null;
                totalEnergyConsumptionNaturalGas?: number | null;
                totalEnergyConsumptionElectricity?: number | null;
            } | null;
        };
    } | null;
};

export type CreateBuildingModelTagsMutationVariables = Exact<{
    data: Array<BuildingModelTagInput> | BuildingModelTagInput;
}>;

export type CreateBuildingModelTagsMutation = {
    __typename?: "Mutation";
    createBuildingModelTags: { __typename?: "PassFailResponse"; error?: string | null; success?: boolean | null };
};

export type DeleteBuildingModelTagsMutationVariables = Exact<{
    data: Array<BuildingModelTagInput> | BuildingModelTagInput;
}>;

export type DeleteBuildingModelTagsMutation = {
    __typename?: "Mutation";
    deleteBuildingModelTags: { __typename?: "PassFailResponse"; error?: string | null; success?: boolean | null };
};

export type AddUsersMutationVariables = Exact<{
    emails: Array<Scalars["String"]> | Scalars["String"];
}>;

export type AddUsersMutation = { __typename?: "Mutation"; addUsers: Array<{ __typename?: "Member"; userId: number }> };

export type RemoveUserMutationVariables = Exact<{
    userId: Scalars["Int"];
}>;

export type RemoveUserMutation = { __typename?: "Mutation"; removeUser: { __typename?: "Member"; userId: number } };

export type SetRolesMutationVariables = Exact<{
    userId: Scalars["Int"];
    roles: Array<Scalars["String"]> | Scalars["String"];
}>;

export type SetRolesMutation = {
    __typename?: "Mutation";
    setRoles: { __typename?: "Member"; userId: number; roles: Array<string> };
};

export type UserQueryVariables = Exact<{ [key: string]: never }>;

export type UserQuery = {
    __typename?: "Query";
    user: {
        __typename?: "User";
        permissions: Array<string>;
        roles: Array<string>;
        userId: string;
        activeOrganization?: {
            __typename?: "Organization";
            name: string;
            customerAccountUid: string;
            createdTimestamp: string;
            members?: Array<{
                __typename?: "Member";
                email: string;
                isActive: boolean;
                roles: Array<string>;
                userId: number;
            }> | null;
        } | null;
        memberOrganizations: Array<{ __typename?: "Organization"; name: string; customerAccountUid: string }>;
    };
};

export type DeleteBuildingModelUtilityDataMutationVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
}>;

export type DeleteBuildingModelUtilityDataMutation = {
    __typename?: "Mutation";
    deleteBuildingModelUtilityData: {
        __typename?: "UpdateBuildingModelResponse";
        error?: string | null;
        buildingModelRunUid?: string | null;
        buildingModelUid?: string | null;
    };
};

export type BuildingModelUtilityDataQueryVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
}>;

export type BuildingModelUtilityDataQuery = {
    __typename?: "Query";
    buildingModelUtilityData: {
        __typename?: "BuildingModelUtilityData";
        error?: string | null;
        buildingModelUtilityData: Array<{
            __typename?: "BuildingModelUtilityDataRow";
            accountNumber?: string | null;
            currency: string;
            utilityRate?: number | null;
            endDate: string;
            energyConsumption: number;
            energyConsumptionUnit: string;
            insertTime: string;
            startDate: string;
            utilityCost?: number | null;
            utilityProvider?: string | null;
            utilityType: UtilityTypes;
        } | null>;
    };
};

export type EnergyAggregationQueryVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
}>;

export type EnergyAggregationQuery = {
    __typename?: "Query";
    energyAggregation: {
        __typename?: "EnergyAggregationByUtilityType";
        error?: string | null;
        electricity?: {
            __typename?: "EnergyAggregation";
            averageUtilityRate?: number | null;
            endDate?: string | null;
            lastUpdated?: string | null;
            startDate?: string | null;
            totalEnergyConsumption?: number | null;
            totalEntries?: number | null;
            totalUtilityCost?: number | null;
        } | null;
        naturalGas?: {
            __typename?: "EnergyAggregation";
            averageUtilityRate?: number | null;
            endDate?: string | null;
            lastUpdated?: string | null;
            startDate?: string | null;
            totalEnergyConsumption?: number | null;
            totalEntries?: number | null;
            totalUtilityCost?: number | null;
        } | null;
    };
};

export type SubmitUtilityDataMutationVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
    utilityData: Array<UtilityData> | UtilityData;
}>;

export type SubmitUtilityDataMutation = {
    __typename?: "Mutation";
    submitUtilityData: {
        __typename?: "SubmitUtilityDataResponse";
        error?: string | null;
        buildingModelRunUid?: string | null;
    };
};

export type DeleteBuildingModelsMutationVariables = Exact<{
    buildingModelUids: Array<Scalars["Uuid"]> | Scalars["Uuid"];
}>;

export type DeleteBuildingModelsMutation = {
    __typename?: "Mutation";
    deleteBuildingModels: { __typename?: "PassFailResponse"; error?: string | null; success?: boolean | null };
};

export type BuildingFootprintsQueryVariables = Exact<{
    address: Address;
    grossFloorArea: Scalars["Float"];
    floorsAboveGrade: Scalars["Int"];
}>;

export type BuildingFootprintsQuery = {
    __typename?: "Query";
    buildingFootprints: {
        __typename?: "BuildingFootprints";
        error?: string | null;
        closestBuildingUid?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        features: Array<{
            __typename?: "FootprintPolygon";
            type: FeatureType;
            geometry: {
                __typename?: "FootprintPolygonGeometry";
                type: GeometryType;
                coordinates: Array<Array<[number, number]>>;
            };
            properties: {
                __typename?: "FootprintPolygonProperties";
                latitude: number;
                longitude: number;
                buildingUid?: string | null;
            };
        }>;
    };
};

export type BuildingModelHeaderQueryVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
}>;

export type BuildingModelHeaderQuery = {
    __typename?: "Query";
    buildingModelHeader: {
        __typename?: "BuildingModelHeader";
        buildingName: string;
        fundName?: string | null;
        propertyName?: string | null;
        tags: Array<string>;
        dataCoverage: {
            __typename?: "DataCoverage";
            dataCoverage: DataCoverageEnum;
            energyType: EnergyTypeEnum;
            energyTypeFromEquipmentData?: EnergyTypeEnum | null;
            energyTypeFromUtilityData?: EnergyTypeEnum | null;
            equipmentDataHasSizeAndYear: boolean;
            equipmentDataUploaded: boolean;
            modellingStatus: ModellingStatus;
            utilityDataUploaded: boolean;
        };
        location: {
            __typename?: "Location";
            streetAddress?: string | null;
            city?: string | null;
            stateProvince?: string | null;
            postalZipCode?: string | null;
            country?: string | null;
            latitude?: number | null;
            longitude?: number | null;
            climateZone?: string | null;
        };
    };
};

export type BuildingModelsTableQueryVariables = Exact<{ [key: string]: never }>;

export type BuildingModelsTableQuery = {
    __typename?: "Query";
    buildingModelsTable: Array<{
        __typename?: "BuildingModelsTableRow";
        annualCarbonEmissionIntensityCurrent?: number | null;
        annualCarbonEmissionsCurrent?: number | null;
        annualCarbonPolicyCostIntensityCurrent?: number | null;
        annualEnergyConsumptionCurrent?: number | null;
        annualEnergyUseIntensityCurrent?: number | null;
        annualUtilityCostIntensityCurrent?: number | null;
        averageMarginalAbatementCost?: number | null;
        buildingArchetype: string;
        buildingModelUid: string;
        buildingName?: string | null;
        carbonEmissionReductionPotential?: number | null;
        createdAt: string;
        lastUpdated: string;
        fundName?: string | null;
        grossFloorArea: number;
        netPresentValueIntensity?: number | null;
        propertyName?: string | null;
        tags: Array<string>;
        yearBuiltOriginal?: number | null;
        dataCoverage: {
            __typename?: "DataCoverage";
            dataCoverage: DataCoverageEnum;
            energyType: EnergyTypeEnum;
            energyTypeFromEquipmentData?: EnergyTypeEnum | null;
            energyTypeFromUtilityData?: EnergyTypeEnum | null;
            equipmentDataHasSizeAndYear: boolean;
            equipmentDataUploaded: boolean;
            modellingStatus: ModellingStatus;
            utilityDataUploaded: boolean;
        };
        location: {
            __typename?: "Location";
            streetAddress?: string | null;
            city?: string | null;
            stateProvince?: string | null;
            postalZipCode?: string | null;
            country?: string | null;
            latitude?: number | null;
            longitude?: number | null;
            climateZone?: string | null;
        };
    } | null>;
};

export type BatchedRemodelBuildingModelsMutationVariables = Exact<{
    buildingModelUids: Array<Scalars["Uuid"]> | Scalars["Uuid"];
}>;

export type BatchedRemodelBuildingModelsMutation = {
    __typename?: "Mutation";
    batchedRemodelBuildingModels: Array<{
        __typename?: "PassFailResponse";
        error?: string | null;
        success?: boolean | null;
    }>;
};

export type UpdateBuildingNameMutationVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
    buildingName: Scalars["String"];
}>;

export type UpdateBuildingNameMutation = {
    __typename?: "Mutation";
    updateBuildingName: { __typename?: "PassFailResponse"; error?: string | null; success?: boolean | null };
};

export type UpdateBuildingModelMutationVariables = Exact<{
    buildingModelUid: Scalars["Uuid"];
    buildingProperties: BuildingProperties;
    carbonPolicyIds?: InputMaybe<Array<Scalars["Int"]> | Scalars["Int"]>;
}>;

export type UpdateBuildingModelMutation = {
    __typename?: "Mutation";
    updateBuildingModel: {
        __typename?: "UpdateBuildingModelResponse";
        error?: string | null;
        buildingModelRunUid?: string | null;
        buildingModelUid?: string | null;
    };
};

export const CreateCustomerAccountDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "createCustomerAccount" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "currencyCode" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "createCustomerAccount" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "name" },
                                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "currencyCode" },
                                value: { kind: "Variable", name: { kind: "Name", value: "currencyCode" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateCustomerAccountMutation, CreateCustomerAccountMutationVariables>;
export const UpdateUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "updateUser" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "userInput" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "UserInput" } },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "userInput" },
                                value: { kind: "Variable", name: { kind: "Name", value: "userInput" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const RemodelBuildingModelsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "remodelBuildingModels" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUids" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "remodelBuildingModels" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUids" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUids" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "success" } },
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<RemodelBuildingModelsMutation, RemodelBuildingModelsMutationVariables>;
export const BuildingBaselineAnnualCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBaselineAnnualCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionsCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalCarbonEmissions" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsElectricity" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsNaturalGas" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingBaselineAnnualCarbonEmissionsCardQuery,
    BuildingBaselineAnnualCarbonEmissionsCardQueryVariables
>;
export const BuildingBaselineAnnualCarbonEmissionsChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBaselineAnnualCarbonEmissionsChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionsChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalCarbonEmissions" } },
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingBaselineAnnualCarbonEmissionsChartQuery,
    BuildingBaselineAnnualCarbonEmissionsChartQueryVariables
>;
export const BuildingBaselineAnnualCarbonEmissionsElectricityChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBaselineAnnualCarbonEmissionsElectricityChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionsElectricityChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "endUseCarbonEmissions" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "carbonEmissions" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingBaselineAnnualCarbonEmissionsElectricityChartQuery,
    BuildingBaselineAnnualCarbonEmissionsElectricityChartQueryVariables
>;
export const BuildingBaselineAnnualCarbonEmissionsNaturalGasChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBaselineAnnualCarbonEmissionsNaturalGasChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionsNaturalGasChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "endUseCarbonEmissions" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "carbonEmissions" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingBaselineAnnualCarbonEmissionsNaturalGasChartQuery,
    BuildingBaselineAnnualCarbonEmissionsNaturalGasChartQueryVariables
>;
export const BuildingBaselineAnnualEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBaselineAnnualEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualEnergyConsumptionCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyConsumption" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionElectricity" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionNaturalGas" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingBaselineAnnualEnergyConsumptionCardQuery,
    BuildingBaselineAnnualEnergyConsumptionCardQueryVariables
>;
export const BuildingBaselineCumulativeCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBaselineCumulativeCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cumulativeCarbonEmissionsCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalCarbonEmissions" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsElectricity" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsNaturalGas" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingBaselineCumulativeCarbonEmissionsCardQuery,
    BuildingBaselineCumulativeCarbonEmissionsCardQueryVariables
>;
export const BuildingBaselineCumulativeEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBaselineCumulativeEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cumulativeEnergyConsumptionCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyConsumption" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionElectricity" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionNaturalGas" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingBaselineCumulativeEnergyConsumptionCardQuery,
    BuildingBaselineCumulativeEnergyConsumptionCardQueryVariables
>;
export const BuildingModelBaselineCurrentAnnualCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingModelBaselineCurrentAnnualCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "currentAnnualCarbonEmissionsCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalEmissionIntensity" } },
                                            { kind: "Field", name: { kind: "Name", value: "totalCarbonEmissions" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingModelBaselineCurrentAnnualCarbonEmissionsCardQuery,
    BuildingModelBaselineCurrentAnnualCarbonEmissionsCardQueryVariables
>;
export const BuildingBaselineCurrentAnnualEndUseChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBaselineCurrentAnnualEndUseChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "currentAnnualEndUseChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "carbonEmissions" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        { kind: "Field", name: { kind: "Name", value: "fuelType" } },
                                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "energyConsumption" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        { kind: "Field", name: { kind: "Name", value: "fuelType" } },
                                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "utilityCost" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        { kind: "Field", name: { kind: "Name", value: "fuelType" } },
                                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingBaselineCurrentAnnualEndUseChartQuery,
    BuildingBaselineCurrentAnnualEndUseChartQueryVariables
>;
export const BuildingBaselineCurrentAnnualEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBaselineCurrentAnnualEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelCarbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "currentAnnualEnergyConsumptionCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyConsumption" } },
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyIntensity" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingBaselineCurrentAnnualEnergyConsumptionCardQuery,
    BuildingBaselineCurrentAnnualEnergyConsumptionCardQueryVariables
>;
export const AnnualCashFlowChartProjectReportDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "annualCashFlowChartProjectReport" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "carbonReductionMeasureUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "measure" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "carbonReductionMeasureUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "carbonReductionMeasureUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCashFlowChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "total" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "carbonPolicyCostSavings" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "calendarYear" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "cashFlowAnnual" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "cashFlowCumulative" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "incrementalCost" },
                                                        },
                                                        { kind: "Field", name: { kind: "Name", value: "revenue" } },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "utilityCostSavingsElectricity",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "utilityCostSavingsNaturalGas",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "likeForLikeCost" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalIncentives" },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "incremental" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "carbonPolicyCostSavings" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "calendarYear" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "cashFlowAnnual" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "cashFlowCumulative" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "incrementalCost" },
                                                        },
                                                        { kind: "Field", name: { kind: "Name", value: "revenue" } },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "utilityCostSavingsElectricity",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "utilityCostSavingsNaturalGas",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalIncentives" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AnnualCashFlowChartProjectReportQuery, AnnualCashFlowChartProjectReportQueryVariables>;
export const MeasureReportDecarbonizationForecastChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "measureReportDecarbonizationForecastChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "carbonReductionMeasureUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "measure" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "carbonReductionMeasureUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "carbonReductionMeasureUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "decarbonizationForecastChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "percentages" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "currentMeasure" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "otherMeasureTypes" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "sameMeasureTypes" },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualData" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "calendarYear" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "carbonEmissionSavingsFromGrid",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "carbonReductionMeasureTypes",
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "carbonEmissionSavings",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "carbonReductionMeasureType",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "carbonReductionMeasureCategory",
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "remainingCarbonEmissions" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MeasureReportDecarbonizationForecastChartQuery,
    MeasureReportDecarbonizationForecastChartQueryVariables
>;
export const TotalCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "totalCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "carbonReductionMeasureUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "measure" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "carbonReductionMeasureUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "carbonReductionMeasureUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "totalCarbonEmissionsCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionSavingsElectricity" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionSavingsNaturalGas" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionSavings" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<TotalCarbonEmissionsCardQuery, TotalCarbonEmissionsCardQueryVariables>;
export const TotalEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "totalEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "carbonReductionMeasureUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "measure" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "carbonReductionMeasureUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "carbonReductionMeasureUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "totalEnergyConsumptionCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionSavings" },
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "totalEnergyConsumptionSavingsElectricity",
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "totalEnergyConsumptionSavingsNaturalGas",
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<TotalEnergyConsumptionCardQuery, TotalEnergyConsumptionCardQueryVariables>;
export const BuildingRecommendationsAnnualCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsAnnualCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionsCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                            { kind: "Field", name: { kind: "Name", value: "totalCarbonEmissions" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionSavings" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsPercentChange" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionIntensity" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsNaturalGas" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsElectricity" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsAnnualCarbonEmissionsCardQuery,
    BuildingRecommendationsAnnualCarbonEmissionsCardQueryVariables
>;
export const BuildingModelRecommendationsAnnualCarbonEmissionsChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingModelRecommendationsAnnualCarbonEmissionsChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionsChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsBaseline" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsRecommendations" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingModelRecommendationsAnnualCarbonEmissionsChartQuery,
    BuildingModelRecommendationsAnnualCarbonEmissionsChartQueryVariables
>;
export const BuildingRecommendationsAnnualCarbonEmissionsElectricityChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsAnnualCarbonEmissionsElectricityChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionsElectricityChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "endUseCarbonEmissions" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "carbonEmissions" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsAnnualCarbonEmissionsElectricityChartQuery,
    BuildingRecommendationsAnnualCarbonEmissionsElectricityChartQueryVariables
>;
export const BuildingRecommendationsAnnualCarbonEmissionsNaturalGasChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsAnnualCarbonEmissionsNaturalGasChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionsNaturalGasChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "endUseCarbonEmissions" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "carbonEmissions" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsAnnualCarbonEmissionsNaturalGasChartQuery,
    BuildingRecommendationsAnnualCarbonEmissionsNaturalGasChartQueryVariables
>;
export const BuildingModelRecommendationsAnnualEmissionSavingsByMeasureChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingModelRecommendationsAnnualEmissionSavingsByMeasureChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualEmissionSavingsByMeasureChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "carbonEmissionSavingsFromGrid" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "carbonReductionMeasureCategories" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "carbonReductionMeasureCategory",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalCarbonEmissionSavings" },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "remainingCarbonEmissions" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingModelRecommendationsAnnualEmissionSavingsByMeasureChartQuery,
    BuildingModelRecommendationsAnnualEmissionSavingsByMeasureChartQueryVariables
>;
export const BuildingModelRecommendationsAnnualEmissionSavingsByMeasureTableDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingModelRecommendationsAnnualEmissionSavingsByMeasureTable" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualEmissionSavingsByMeasureTable" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualCarbonEmissionSavings" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualEnergyConsumptionSavings" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "annualEnergyCostSavings" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "carbonReductionMeasureCategory" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "carbonReductionMeasureType" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "impactPercentage" } },
                                            { kind: "Field", name: { kind: "Name", value: "incrementalCost" } },
                                            { kind: "Field", name: { kind: "Name", value: "likeForLikeCost" } },
                                            { kind: "Field", name: { kind: "Name", value: "yearApplied" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingModelRecommendationsAnnualEmissionSavingsByMeasureTableQuery,
    BuildingModelRecommendationsAnnualEmissionSavingsByMeasureTableQueryVariables
>;
export const BuildingRecommendationsAnnualEndUse2050ChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsAnnualEndUse2050Chart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualEndUse2050Chart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "carbonEmissions" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        { kind: "Field", name: { kind: "Name", value: "fuelType" } },
                                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "energyConsumption" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        { kind: "Field", name: { kind: "Name", value: "fuelType" } },
                                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "utilityCost" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                                        { kind: "Field", name: { kind: "Name", value: "fuelType" } },
                                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsAnnualEndUse2050ChartQuery,
    BuildingRecommendationsAnnualEndUse2050ChartQueryVariables
>;
export const BuildingRecommendationsAnnualEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsAnnualEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualEnergyConsumptionCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyConsumption" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionSavings" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionPercentChange" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyIntensity" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionNaturalGas" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionElectricity" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "year" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsAnnualEnergyConsumptionCardQuery,
    BuildingRecommendationsAnnualEnergyConsumptionCardQueryVariables
>;
export const BuildingRecommendationsAverageMarginalAbatementCostByMeasureCategoryChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsAverageMarginalAbatementCostByMeasureCategoryChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "averageMarginalAbatementCostByMeasureCategoryChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "carbonReductionMeasureCategory" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "averageMarginalAbatementCost" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalLifetimeCarbonEmissionSavings" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsAverageMarginalAbatementCostByMeasureCategoryChartQuery,
    BuildingRecommendationsAverageMarginalAbatementCostByMeasureCategoryChartQueryVariables
>;
export const BuildingRecommendationsCumulativeCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsCumulativeCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cumulativeCarbonEmissionsCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalCarbonEmissions" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionSavings" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsPercentChange" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionIntensity" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsNaturalGas" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionsElectricity" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsCumulativeCarbonEmissionsCardQuery,
    BuildingRecommendationsCumulativeCarbonEmissionsCardQueryVariables
>;
export const BuildingRecommendationsCumulativeEmissionSavingsCardRecommendationsReportDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsCumulativeEmissionSavingsCardRecommendationsReport" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cumulativeEmissionSavingsCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionSavings" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionSavingsFromMeasures" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalCarbonEmissionSavingsFromGrid" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsCumulativeEmissionSavingsCardRecommendationsReportQuery,
    BuildingRecommendationsCumulativeEmissionSavingsCardRecommendationsReportQueryVariables
>;
export const BuildingRecommendationsCumulativeEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsCumulativeEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cumulativeEnergyConsumptionCard" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyConsumption" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionSavings" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionPercentChange" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyIntensity" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionNaturalGas" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "totalEnergyConsumptionElectricity" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsCumulativeEnergyConsumptionCardQuery,
    BuildingRecommendationsCumulativeEnergyConsumptionCardQueryVariables
>;
export const BuildingRecommendationsCumulativeInvestmentByDecarbonizationChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingRecommendationsCumulativeInvestmentByDecarbonizationChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "carbonReductionPlanReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "buildingModelCarbonReductionPlanId" },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cumulativeInvestmentByDecarbonizationChart" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "totalMeasureCost" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "decarbonizationPercentage" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    BuildingRecommendationsCumulativeInvestmentByDecarbonizationChartQuery,
    BuildingRecommendationsCumulativeInvestmentByDecarbonizationChartQueryVariables
>;
export const BuildingModelConstructionDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingModelConstruction" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelConstruction" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "streetAddress" } },
                                            { kind: "Field", name: { kind: "Name", value: "city" } },
                                            { kind: "Field", name: { kind: "Name", value: "stateProvince" } },
                                            { kind: "Field", name: { kind: "Name", value: "postalZipCode" } },
                                            { kind: "Field", name: { kind: "Name", value: "country" } },
                                            { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                            { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                            { kind: "Field", name: { kind: "Name", value: "climateZone" } },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "buildingArchetype" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "buildingFootprint" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "type" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "geometry" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                                        { kind: "Field", name: { kind: "Name", value: "coordinates" } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "properties" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                                        { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                                        { kind: "Field", name: { kind: "Name", value: "buildingUid" } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "yearBuiltOriginal" } },
                                { kind: "Field", name: { kind: "Name", value: "grossFloorArea" } },
                                { kind: "Field", name: { kind: "Name", value: "floorsAboveGrade" } },
                                { kind: "Field", name: { kind: "Name", value: "ledInstalledRatio" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingHeight" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingUid" } },
                                { kind: "Field", name: { kind: "Name", value: "footprintArea" } },
                                { kind: "Field", name: { kind: "Name", value: "wallRValue" } },
                                { kind: "Field", name: { kind: "Name", value: "roofArea" } },
                                { kind: "Field", name: { kind: "Name", value: "availableRoofAreaRatio" } },
                                { kind: "Field", name: { kind: "Name", value: "roofRValue" } },
                                { kind: "Field", name: { kind: "Name", value: "roofInstallationYear" } },
                                { kind: "Field", name: { kind: "Name", value: "windowSolarHeatGainCoefficient" } },
                                { kind: "Field", name: { kind: "Name", value: "windowToWallRatio" } },
                                { kind: "Field", name: { kind: "Name", value: "windowRValue" } },
                                { kind: "Field", name: { kind: "Name", value: "windowInstallationYear" } },
                                { kind: "Field", name: { kind: "Name", value: "coolingMultiplier" } },
                                { kind: "Field", name: { kind: "Name", value: "fansMultiplier" } },
                                { kind: "Field", name: { kind: "Name", value: "heatingMultiplier" } },
                                { kind: "Field", name: { kind: "Name", value: "lightingMultiplier" } },
                                { kind: "Field", name: { kind: "Name", value: "plugLoadMultiplier" } },
                                { kind: "Field", name: { kind: "Name", value: "processMultiplier" } },
                                { kind: "Field", name: { kind: "Name", value: "pumpsMultiplier" } },
                                { kind: "Field", name: { kind: "Name", value: "domesticHotWaterMultiplier" } },
                                { kind: "Field", name: { kind: "Name", value: "ventilationRateMultiplier" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultDiscountRate" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "defaultGridIntensityScheduleScenario" },
                                },
                                { kind: "Field", name: { kind: "Name", value: "defaultWeightEmissionSavings" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultWeightNetPresentValue" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultUtilityInflationRate" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultElectricityUtilityRate" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultNaturalGasUtilityRate" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultSteamUtilityRate" } },
                                { kind: "Field", name: { kind: "Name", value: "assumedHeatingEnergyType" } },
                                { kind: "Field", name: { kind: "Name", value: "assumedCoolingEnergyType" } },
                                { kind: "Field", name: { kind: "Name", value: "assumedDhwEnergyType" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultLandlordShareCost" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultLandlordShareElectricity" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultLandlordShareNaturalGas" } },
                                { kind: "Field", name: { kind: "Name", value: "defaultLandlordShareSteam" } },
                                { kind: "Field", name: { kind: "Name", value: "assumedGrossAssetValue" } },
                                { kind: "Field", name: { kind: "Name", value: "customerBuildingIdentifier" } },
                                { kind: "Field", name: { kind: "Name", value: "notes" } },
                                { kind: "Field", name: { kind: "Name", value: "leasingStructure" } },
                                { kind: "Field", name: { kind: "Name", value: "assumedExitCapRate" } },
                                { kind: "Field", name: { kind: "Name", value: "assumedExitYear" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BuildingModelConstructionQuery, BuildingModelConstructionQueryVariables>;
export const CreateCustomPlanFromPlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "createCustomPlanFromPlan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "carbonReductionPlanUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "planName" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "createCustomPlanFromPlan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "carbonReductionPlanUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "carbonReductionPlanUid" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "planName" },
                                value: { kind: "Variable", name: { kind: "Name", value: "planName" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateCustomPlanFromPlanMutation, CreateCustomPlanFromPlanMutationVariables>;
export const DeleteCustomCarbonReductionPlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteCustomCarbonReductionPlan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "carbonReductionPlanUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteCustomCarbonReductionPlan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "carbonReductionPlanUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "carbonReductionPlanUid" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteCustomCarbonReductionPlanMutation, DeleteCustomCarbonReductionPlanMutationVariables>;
export const PublishPlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "publishPlan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "publishPlan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PublishPlanMutation, PublishPlanMutationVariables>;
export const ReportPlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "reportPlan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "reportPlan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ReportPlanMutation, ReportPlanMutationVariables>;
export const UnpublishPlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "unpublishPlan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "unpublishPlan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UnpublishPlanMutation, UnpublishPlanMutationVariables>;
export const UnreportPlanDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "unreportPlan" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "unreportPlan" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UnreportPlanMutation, UnreportPlanMutationVariables>;
export const UpdateCustomPlanMeasuresDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "updateCustomPlanMeasures" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "measures" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: { kind: "NamedType", name: { kind: "Name", value: "CarbonReductionMeasureInput" } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "updateCustomPlanMeasures" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "measures" },
                                value: { kind: "Variable", name: { kind: "Name", value: "measures" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateCustomPlanMeasuresMutation, UpdateCustomPlanMeasuresMutationVariables>;
export const UpdateCustomPlanNameDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "updateCustomPlanName" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "updateCustomPlanName" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "id" },
                                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "name" },
                                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateCustomPlanNameMutation, UpdateCustomPlanNameMutationVariables>;
export const DeleteEquipmentSurveyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteEquipmentSurvey" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteEquipmentSurvey" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingModelRunUid" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingModelUid" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteEquipmentSurveyMutation, DeleteEquipmentSurveyMutationVariables>;
export const EquipmentSurveyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "equipmentSurvey" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "equipmentSurvey" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "airHandlingEquipment" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "airHandlingEquipmentExists" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "airHandlingEquipmentType" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "airHandlingEquipmentHeatingType" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "airHandlingEquipmentCoolingType" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "airHandlingEquipmentSupplyAirRate" },
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "airHandlingEquipmentAverageInstallationYear",
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "centralPlantCooler" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "centralPlantCoolerExists" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "centralPlantCoolerType" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "centralPlantCoolerTerminalUnits" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "centralPlantCoolerSize" } },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "centralPlantCoolerAverageInstallationYear",
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "centralPlantHeater" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "centralPlantHeaterExists" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "centralPlantHeaterType" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "centralPlantHeaterTerminalUnits" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "centralPlantHeaterSize" } },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "centralPlantHeaterAverageInstallationYear",
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "centralPlantHeatPump" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "centralPlantHeatPumpExists" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "centralPlantHeatPumpType" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "centralPlantHeatPumpSize" },
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "centralPlantHeatPumpAverageInstallationYear",
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "genericHVACEquipment" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "name" } },
                                            { kind: "Field", name: { kind: "Name", value: "size" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "coefficientOfPerformance" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "endUse" } },
                                            { kind: "Field", name: { kind: "Name", value: "fuel" } },
                                            { kind: "Field", name: { kind: "Name", value: "installationYear" } },
                                            { kind: "Field", name: { kind: "Name", value: "lifeSpan" } },
                                            { kind: "Field", name: { kind: "Name", value: "loadRatio" } },
                                            { kind: "Field", name: { kind: "Name", value: "sizeUnits" } },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "domesticHotWaterHeater" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "domesticHotWaterHeaterExists" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "domesticHotWaterHeaterType" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "domesticHotWaterHeaterSize" },
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "domesticHotWaterHeaterAverageInstallationYear",
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "domesticHotWaterHeaterCentralDistribution",
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "heatPump" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "heatPumpExists" } },
                                            { kind: "Field", name: { kind: "Name", value: "heatPumpType" } },
                                            { kind: "Field", name: { kind: "Name", value: "heatPumpSize" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "heatPumpInstallationYear" },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "otherEquipment" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "clothesDryersExists" } },
                                            { kind: "Field", name: { kind: "Name", value: "clothesDryersType" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "clothesDryersEnergyDensity" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "clothesDryersAverageInstallationYear" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "clothesWashersExists" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "clothesWashersEnergyDensity" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "clothesWashersAverageInstallationYear" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "escalatorExists" } },
                                            { kind: "Field", name: { kind: "Name", value: "escalatorQuantity" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "escalatorInstallationYear" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "elevatorsExists" } },
                                            { kind: "Field", name: { kind: "Name", value: "elevatorsQuantity" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "elevatorsAverageInstallationYear" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "rooftopPhotovoltaicsExists" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "rooftopPhotovoltaicsSize" },
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "rooftopPhotovoltaicsAverageInstallationYear",
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rooftopUnit" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "rooftopUnitExists" } },
                                            { kind: "Field", name: { kind: "Name", value: "rooftopUnitHeatingType" } },
                                            { kind: "Field", name: { kind: "Name", value: "rooftopUnitCoolingType" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "rooftopUnitSupplyAirRate" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "rooftopUnitAverageInstallationYear" },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "terminalCooler" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "terminalCoolerExists" } },
                                            { kind: "Field", name: { kind: "Name", value: "terminalCoolerUnits" } },
                                            { kind: "Field", name: { kind: "Name", value: "terminalCoolerSize" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "terminalCoolerAverageInstallationYear" },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "terminalHeater" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "terminalHeaterCoolerSize" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "terminalHeaterExists" } },
                                            { kind: "Field", name: { kind: "Name", value: "terminalHeaterUnits" } },
                                            { kind: "Field", name: { kind: "Name", value: "terminalHeaterSize" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "terminalHeaterAverageInstallationYear" },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<EquipmentSurveyQuery, EquipmentSurveyQueryVariables>;
export const SubmitEquipmentSurveyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "submitEquipmentSurvey" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "equipmentSurvey" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "EquipmentSurveyInput" } },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "submitEquipmentSurvey" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "equipmentSurvey" },
                                value: { kind: "Variable", name: { kind: "Name", value: "equipmentSurvey" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "success" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SubmitEquipmentSurveyMutation, SubmitEquipmentSurveyMutationVariables>;
export const FundsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "funds" },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "funds" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionIntensityCurrent" },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonPolicyCostIntensityCurrent" },
                                },
                                { kind: "Field", name: { kind: "Name", value: "annualEnergyUseIntensityCurrent" } },
                                { kind: "Field", name: { kind: "Name", value: "annualUtilityCostIntensityCurrent" } },
                                { kind: "Field", name: { kind: "Name", value: "averageMarginalAbatementCost" } },
                                { kind: "Field", name: { kind: "Name", value: "carbonEmissionReductionPotential" } },
                                { kind: "Field", name: { kind: "Name", value: "fundId" } },
                                { kind: "Field", name: { kind: "Name", value: "fundName" } },
                                { kind: "Field", name: { kind: "Name", value: "grossFloorArea" } },
                                { kind: "Field", name: { kind: "Name", value: "netPresentValueIntensity" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "properties" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "propertyUid" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "buildingModels" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "buildingModelUid" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "dataCoverage" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "dataCoverage" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "energyType" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "energyTypeFromEquipmentData",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "energyTypeFromUtilityData",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "equipmentDataHasSizeAndYear",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "equipmentDataUploaded",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "modellingStatus",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "utilityDataUploaded",
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        { kind: "Field", name: { kind: "Name", value: "tags" } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<FundsQuery, FundsQueryVariables>;
export const SetPropertyFundDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "setPropertyFund" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "propertyUids" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                            },
                        },
                    },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "fundName" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "setPropertyFund" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "propertyUids" },
                                value: { kind: "Variable", name: { kind: "Name", value: "propertyUids" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "fundName" },
                                value: { kind: "Variable", name: { kind: "Name", value: "fundName" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "success" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SetPropertyFundMutation, SetPropertyFundMutationVariables>;
export const CreateReportFiltersetDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "createReportFilterset" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFilter" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "ReportFilter" } },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "createReportFilterset" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFilter" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFilter" } },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateReportFiltersetMutation, CreateReportFiltersetMutationVariables>;
export const PropertiesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "properties" },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "properties" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionIntensityCurrent" },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonPolicyCostIntensityCurrent" },
                                },
                                { kind: "Field", name: { kind: "Name", value: "annualEnergyUseIntensityCurrent" } },
                                { kind: "Field", name: { kind: "Name", value: "annualUtilityCostIntensityCurrent" } },
                                { kind: "Field", name: { kind: "Name", value: "averageMarginalAbatementCost" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "buildingModels" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "buildingArchetype" } },
                                            { kind: "Field", name: { kind: "Name", value: "buildingModelUid" } },
                                            { kind: "Field", name: { kind: "Name", value: "buildingName" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "dataCoverage" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "dataCoverage" },
                                                        },
                                                        { kind: "Field", name: { kind: "Name", value: "energyType" } },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "energyTypeFromEquipmentData",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "energyTypeFromUtilityData" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "equipmentDataHasSizeAndYear",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "equipmentDataUploaded" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "modellingStatus" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "utilityDataUploaded" },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "location" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "streetAddress" },
                                                        },
                                                        { kind: "Field", name: { kind: "Name", value: "city" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "stateProvince" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "postalZipCode" },
                                                        },
                                                        { kind: "Field", name: { kind: "Name", value: "country" } },
                                                        { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                                        { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                                        { kind: "Field", name: { kind: "Name", value: "climateZone" } },
                                                    ],
                                                },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "carbonEmissionReductionPotential" } },
                                { kind: "Field", name: { kind: "Name", value: "fundName" } },
                                { kind: "Field", name: { kind: "Name", value: "grossFloorArea" } },
                                { kind: "Field", name: { kind: "Name", value: "netPresentValueIntensity" } },
                                { kind: "Field", name: { kind: "Name", value: "propertyName" } },
                                { kind: "Field", name: { kind: "Name", value: "propertyUid" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PropertiesQuery, PropertiesQueryVariables>;
export const SetBuildingModelPropertyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "setBuildingModelProperty" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUids" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                            },
                        },
                    },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "propertyName" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "setBuildingModelProperty" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUids" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUids" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "propertyName" },
                                value: { kind: "Variable", name: { kind: "Name", value: "propertyName" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "success" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SetBuildingModelPropertyMutation, SetBuildingModelPropertyMutationVariables>;
export const AnnualCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "annualCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualCarbonEmissionsCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "error" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "data" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalCarbonEmissions",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalCarbonEmissionsElectricity",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalCarbonEmissionsNaturalGas",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "year" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AnnualCarbonEmissionsCardQuery, AnnualCarbonEmissionsCardQueryVariables>;
export const AnnualCarbonEmissionsChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "annualCarbonEmissionsChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualCarbonEmissionsChart" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "error" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "data" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalCarbonEmissions",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "year" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AnnualCarbonEmissionsChartQuery, AnnualCarbonEmissionsChartQueryVariables>;
export const QueryBaselineAnnualCarbonEmissionsElectricityChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "queryBaselineAnnualCarbonEmissionsElectricityChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualCarbonEmissionsElectricityChart" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "year" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "endUseCarbonEmissions" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "carbonEmissions",
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    QueryBaselineAnnualCarbonEmissionsElectricityChartQuery,
    QueryBaselineAnnualCarbonEmissionsElectricityChartQueryVariables
>;
export const QueryBaselineAnnualCarbonEmissionsNaturalGasChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "queryBaselineAnnualCarbonEmissionsNaturalGasChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualCarbonEmissionsNaturalGasChart" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "year" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "endUseCarbonEmissions" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "carbonEmissions",
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    QueryBaselineAnnualCarbonEmissionsNaturalGasChartQuery,
    QueryBaselineAnnualCarbonEmissionsNaturalGasChartQueryVariables
>;
export const AnnualEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "annualEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualEnergyConsumptionCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "error" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "data" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalEnergyConsumption",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalEnergyConsumptionElectricity",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalEnergyConsumptionNaturalGas",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "year" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AnnualEnergyConsumptionCardQuery, AnnualEnergyConsumptionCardQueryVariables>;
export const BuildingBarChartAndMapDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBarChartAndMap" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "buildingBarChartAndMap" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "annualCarbonEmissionIntensityCurrent",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "annualCarbonEmissionsCurrent",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "annualEnergyConsumptionCurrent",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "annualEnergyUseIntensityCurrent",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "buildingModelUid" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "location" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "streetAddress" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "city" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "stateProvince" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "postalZipCode" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "country" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "latitude" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "longitude" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "climateZone" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BuildingBarChartAndMapQuery, BuildingBarChartAndMapQueryVariables>;
export const BuildingBarChartAndMapByPropertyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingBarChartAndMapByProperty" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "buildingBarChartAndMapByProperty" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "averageAnnualCarbonEmissionIntensityCurrent",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "averageAnnualEnergyUseIntensityCurrent",
                                                            },
                                                        },
                                                        { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                                        { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "propertyName" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalAnnualCarbonEmissionsCurrent",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalAnnualEnergyConsumptionCurrent",
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BuildingBarChartAndMapByPropertyQuery, BuildingBarChartAndMapByPropertyQueryVariables>;
export const BuildingCountDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingCount" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [{ kind: "Field", name: { kind: "Name", value: "buildingCount" } }],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BuildingCountQuery, BuildingCountQueryVariables>;
export const CumulativeCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "cumulativeCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "cumulativeCarbonEmissionsCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "error" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalCarbonEmissions" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionsElectricity",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionsNaturalGas",
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CumulativeCarbonEmissionsCardQuery, CumulativeCarbonEmissionsCardQueryVariables>;
export const CumulativeEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "cumulativeEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "cumulativeEnergyConsumptionCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "error" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalEnergyConsumption" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionElectricity",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionNaturalGas",
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CumulativeEnergyConsumptionCardQuery, CumulativeEnergyConsumptionCardQueryVariables>;
export const CurrentAnnualCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "currentAnnualCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "currentAnnualCarbonEmissionsCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "error" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "averageEmissionsIntensity" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalCarbonEmissions" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CurrentAnnualCarbonEmissionsCardQuery, CurrentAnnualCarbonEmissionsCardQueryVariables>;
export const CurrentAnnualEndUseChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "currentAnnualEndUseChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "currentAnnualEndUseChart" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "error" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "carbonEmissions" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "fuelType" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "value" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "energyConsumption" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "fuelType" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "value" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "utilityCost" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "fuelType" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "value" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CurrentAnnualEndUseChartQuery, CurrentAnnualEndUseChartQueryVariables>;
export const CurrentAnnualEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "currentAnnualEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "currentAnnualEnergyConsumptionCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "error" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "averageEnergyIntensity" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalEnergyConsumption" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CurrentAnnualEnergyConsumptionCardQuery, CurrentAnnualEnergyConsumptionCardQueryVariables>;
export const CurrentAnnualEnergyCostCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "currentAnnualEnergyCostCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredBaselineReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "currentAnnualEnergyCostCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalEnergyCost" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "landlordEnergyCost" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "tenantEnergyCost" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CurrentAnnualEnergyCostCardQuery, CurrentAnnualEnergyCostCardQueryVariables>;
export const RecommendationsAnnualCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "recommendationsAnnualCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualCarbonEmissionsCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "year" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalCarbonEmissions" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalCarbonEmissionSavings" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionsPercentChange",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "averageCarbonEmissionIntensity",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionsNaturalGas",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionsElectricity",
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    RecommendationsAnnualCarbonEmissionsCardQuery,
    RecommendationsAnnualCarbonEmissionsCardQueryVariables
>;
export const RecommendationsAnnualCarbonEmissionsChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "recommendationsAnnualCarbonEmissionsChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualCarbonEmissionsChart" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionsBaseline",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalCarbonEmissionsGoal" },
                                                        },
                                                        { kind: "Field", name: { kind: "Name", value: "year" } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    RecommendationsAnnualCarbonEmissionsChartQuery,
    RecommendationsAnnualCarbonEmissionsChartQueryVariables
>;
export const QueryAnnualCarbonEmissionsElectricityChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "queryAnnualCarbonEmissionsElectricityChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualCarbonEmissionsElectricityChart" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "year" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "endUseCarbonEmissions" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "carbonEmissions",
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    QueryAnnualCarbonEmissionsElectricityChartQuery,
    QueryAnnualCarbonEmissionsElectricityChartQueryVariables
>;
export const AnnualCarbonEmissionsNaturalGasChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "annualCarbonEmissionsNaturalGasChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualCarbonEmissionsNaturalGasChart" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "year" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "endUseCarbonEmissions" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "carbonEmissions",
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    AnnualCarbonEmissionsNaturalGasChartQuery,
    AnnualCarbonEmissionsNaturalGasChartQueryVariables
>;
export const AnnualEmissionSavingsByMeasureChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "annualEmissionSavingsByMeasureChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualEmissionSavingsByMeasureChart" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "carbonEmissionSavingsFromGrid",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "carbonReductionMeasureCategories",
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "carbonReductionMeasureCategory",
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalCarbonEmissionSavings",
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "remainingCarbonEmissions" },
                                                        },
                                                        { kind: "Field", name: { kind: "Name", value: "year" } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    AnnualEmissionSavingsByMeasureChartQuery,
    AnnualEmissionSavingsByMeasureChartQueryVariables
>;
export const AnnualEmissionSavingsByMeasureTableDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "annualEmissionSavingsByMeasureTable" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualEmissionSavingsByMeasureTable" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "impactPercentage" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "carbonReductionMeasureCategory",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "measureCount" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalAnnualCarbonEmissionSavings",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalAnnualEnergyConsumptionSavings",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalAnnualEnergyCostSavings",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalMeasureCost" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    AnnualEmissionSavingsByMeasureTableQuery,
    AnnualEmissionSavingsByMeasureTableQueryVariables
>;
export const QueryAnnualEndUse2050ChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "queryAnnualEndUse2050Chart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualEndUse2050Chart" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "carbonEmissions" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "fuelType" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "value" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "energyConsumption" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "fuelType" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "value" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "utilityCost" },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "endUse" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "fuelType" },
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: { kind: "Name", value: "value" },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<QueryAnnualEndUse2050ChartQuery, QueryAnnualEndUse2050ChartQueryVariables>;
export const RecommendationsAnnualEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "recommendationsAnnualEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "annualEnergyConsumptionCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "year" } },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalEnergyConsumption" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionSavings",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionPercentChange",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "averageEnergyIntensity" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionNaturalGas",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionElectricity",
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    RecommendationsAnnualEnergyConsumptionCardQuery,
    RecommendationsAnnualEnergyConsumptionCardQueryVariables
>;
export const AverageMarginalAbatementCostByMeasureCategoryChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "averageMarginalAbatementCostByMeasureCategoryChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "averageMarginalAbatementCostByMeasureCategoryChart",
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "carbonReductionMeasureCategory",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "averageMarginalAbatementCost",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalLifetimeCarbonEmissionSavings",
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    AverageMarginalAbatementCostByMeasureCategoryChartQuery,
    AverageMarginalAbatementCostByMeasureCategoryChartQueryVariables
>;
export const RecommendationsCumulativeCarbonEmissionsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "recommendationsCumulativeCarbonEmissionsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "cumulativeCarbonEmissionsCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalCarbonEmissions" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalCarbonEmissionSavings" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionsPercentChange",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "averageCarbonEmissionIntensity",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionsNaturalGas",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionsElectricity",
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    RecommendationsCumulativeCarbonEmissionsCardQuery,
    RecommendationsCumulativeCarbonEmissionsCardQueryVariables
>;
export const CumulativeEmissionSavingsCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "cumulativeEmissionSavingsCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "cumulativeEmissionSavingsCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalCarbonEmissionSavings" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionSavingsFromMeasures",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCarbonEmissionSavingsFromGrid",
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CumulativeEmissionSavingsCardQuery, CumulativeEmissionSavingsCardQueryVariables>;
export const CumulativeInvestmentByDecarbonizationChartDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "cumulativeInvestmentByDecarbonizationChart" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cumulativeInvestmentByDecarbonizationChart",
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalMeasureCost" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "decarbonizationPercentage" },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CumulativeInvestmentByDecarbonizationChartQuery,
    CumulativeInvestmentByDecarbonizationChartQueryVariables
>;
export const RecommendationsCumulativeEnergyConsumptionCardDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "recommendationsCumulativeEnergyConsumptionCard" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                    type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "prefilteredReports" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "reportFiltersetUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "reportFiltersetUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "prefilteredRecommendationsReport" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "cumulativeEnergyConsumptionCard" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "totalEnergyConsumption" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionSavings",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionPercentChange",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "averageEnergyIntensity" },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionNaturalGas",
                                                            },
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalEnergyConsumptionElectricity",
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    RecommendationsCumulativeEnergyConsumptionCardQuery,
    RecommendationsCumulativeEnergyConsumptionCardQueryVariables
>;
export const CreateBuildingModelTagsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "createBuildingModelTags" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "BuildingModelTagInput" } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "createBuildingModelTags" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "data" },
                                value: { kind: "Variable", name: { kind: "Name", value: "data" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "success" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateBuildingModelTagsMutation, CreateBuildingModelTagsMutationVariables>;
export const DeleteBuildingModelTagsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteBuildingModelTags" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "BuildingModelTagInput" } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteBuildingModelTags" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "data" },
                                value: { kind: "Variable", name: { kind: "Name", value: "data" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "success" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteBuildingModelTagsMutation, DeleteBuildingModelTagsMutationVariables>;
export const AddUsersDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "addUsers" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "emails" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "addUsers" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "emails" },
                                value: { kind: "Variable", name: { kind: "Name", value: "emails" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "userId" } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AddUsersMutation, AddUsersMutationVariables>;
export const RemoveUserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "removeUser" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "removeUser" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "userId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [{ kind: "Field", name: { kind: "Name", value: "userId" } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<RemoveUserMutation, RemoveUserMutationVariables>;
export const SetRolesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "setRoles" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "roles" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "setRoles" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "userId" },
                                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "roles" },
                                value: { kind: "Variable", name: { kind: "Name", value: "roles" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "userId" } },
                                { kind: "Field", name: { kind: "Name", value: "roles" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SetRolesMutation, SetRolesMutationVariables>;
export const UserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "user" },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "activeOrganization" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "name" } },
                                            { kind: "Field", name: { kind: "Name", value: "customerAccountUid" } },
                                            { kind: "Field", name: { kind: "Name", value: "createdTimestamp" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "members" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "email" } },
                                                        { kind: "Field", name: { kind: "Name", value: "isActive" } },
                                                        { kind: "Field", name: { kind: "Name", value: "roles" } },
                                                        { kind: "Field", name: { kind: "Name", value: "userId" } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "memberOrganizations" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "name" } },
                                            { kind: "Field", name: { kind: "Name", value: "customerAccountUid" } },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "permissions" } },
                                { kind: "Field", name: { kind: "Name", value: "roles" } },
                                { kind: "Field", name: { kind: "Name", value: "userId" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const DeleteBuildingModelUtilityDataDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteBuildingModelUtilityData" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteBuildingModelUtilityData" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingModelRunUid" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingModelUid" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteBuildingModelUtilityDataMutation, DeleteBuildingModelUtilityDataMutationVariables>;
export const BuildingModelUtilityDataDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingModelUtilityData" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelUtilityData" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "buildingModelUtilityData" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "accountNumber" } },
                                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                                            { kind: "Field", name: { kind: "Name", value: "utilityRate" } },
                                            { kind: "Field", name: { kind: "Name", value: "endDate" } },
                                            { kind: "Field", name: { kind: "Name", value: "energyConsumption" } },
                                            { kind: "Field", name: { kind: "Name", value: "energyConsumptionUnit" } },
                                            { kind: "Field", name: { kind: "Name", value: "insertTime" } },
                                            { kind: "Field", name: { kind: "Name", value: "startDate" } },
                                            { kind: "Field", name: { kind: "Name", value: "utilityCost" } },
                                            { kind: "Field", name: { kind: "Name", value: "utilityProvider" } },
                                            { kind: "Field", name: { kind: "Name", value: "utilityType" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BuildingModelUtilityDataQuery, BuildingModelUtilityDataQueryVariables>;
export const EnergyAggregationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "energyAggregation" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "energyAggregation" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "electricity" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "averageUtilityRate" } },
                                            { kind: "Field", name: { kind: "Name", value: "endDate" } },
                                            { kind: "Field", name: { kind: "Name", value: "lastUpdated" } },
                                            { kind: "Field", name: { kind: "Name", value: "startDate" } },
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyConsumption" } },
                                            { kind: "Field", name: { kind: "Name", value: "totalEntries" } },
                                            { kind: "Field", name: { kind: "Name", value: "totalUtilityCost" } },
                                        ],
                                    },
                                },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "naturalGas" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "averageUtilityRate" } },
                                            { kind: "Field", name: { kind: "Name", value: "endDate" } },
                                            { kind: "Field", name: { kind: "Name", value: "lastUpdated" } },
                                            { kind: "Field", name: { kind: "Name", value: "startDate" } },
                                            { kind: "Field", name: { kind: "Name", value: "totalEnergyConsumption" } },
                                            { kind: "Field", name: { kind: "Name", value: "totalEntries" } },
                                            { kind: "Field", name: { kind: "Name", value: "totalUtilityCost" } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<EnergyAggregationQuery, EnergyAggregationQueryVariables>;
export const SubmitUtilityDataDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "submitUtilityData" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "utilityData" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "UtilityData" } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "submitUtilityData" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "utilityData" },
                                value: { kind: "Variable", name: { kind: "Name", value: "utilityData" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingModelRunUid" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SubmitUtilityDataMutation, SubmitUtilityDataMutationVariables>;
export const DeleteBuildingModelsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "deleteBuildingModels" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUids" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "deleteBuildingModels" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUids" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUids" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "success" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteBuildingModelsMutation, DeleteBuildingModelsMutationVariables>;
export const BuildingFootprintsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingFootprints" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "address" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
                    },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "grossFloorArea" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Float" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "floorsAboveGrade" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingFootprints" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "address" },
                                value: { kind: "Variable", name: { kind: "Name", value: "address" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "grossFloorArea" },
                                value: { kind: "Variable", name: { kind: "Name", value: "grossFloorArea" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "floorsAboveGrade" },
                                value: { kind: "Variable", name: { kind: "Name", value: "floorsAboveGrade" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "closestBuildingUid" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "features" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "type" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "geometry" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                                        { kind: "Field", name: { kind: "Name", value: "coordinates" } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "properties" },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                                        { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                                        { kind: "Field", name: { kind: "Name", value: "buildingUid" } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                { kind: "Field", name: { kind: "Name", value: "longitude" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BuildingFootprintsQuery, BuildingFootprintsQueryVariables>;
export const BuildingModelHeaderDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingModelHeader" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelHeader" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "buildingName" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "dataCoverage" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "dataCoverage" } },
                                            { kind: "Field", name: { kind: "Name", value: "energyType" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "energyTypeFromEquipmentData" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "energyTypeFromUtilityData" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "equipmentDataHasSizeAndYear" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "equipmentDataUploaded" } },
                                            { kind: "Field", name: { kind: "Name", value: "modellingStatus" } },
                                            { kind: "Field", name: { kind: "Name", value: "utilityDataUploaded" } },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "fundName" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "streetAddress" } },
                                            { kind: "Field", name: { kind: "Name", value: "city" } },
                                            { kind: "Field", name: { kind: "Name", value: "stateProvince" } },
                                            { kind: "Field", name: { kind: "Name", value: "postalZipCode" } },
                                            { kind: "Field", name: { kind: "Name", value: "country" } },
                                            { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                            { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                            { kind: "Field", name: { kind: "Name", value: "climateZone" } },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "propertyName" } },
                                { kind: "Field", name: { kind: "Name", value: "tags" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BuildingModelHeaderQuery, BuildingModelHeaderQueryVariables>;
export const BuildingModelsTableDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: { kind: "Name", value: "buildingModelsTable" },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "buildingModelsTable" },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonEmissionIntensityCurrent" },
                                },
                                { kind: "Field", name: { kind: "Name", value: "annualCarbonEmissionsCurrent" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "annualCarbonPolicyCostIntensityCurrent" },
                                },
                                { kind: "Field", name: { kind: "Name", value: "annualEnergyConsumptionCurrent" } },
                                { kind: "Field", name: { kind: "Name", value: "annualEnergyUseIntensityCurrent" } },
                                { kind: "Field", name: { kind: "Name", value: "annualUtilityCostIntensityCurrent" } },
                                { kind: "Field", name: { kind: "Name", value: "averageMarginalAbatementCost" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingArchetype" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingModelUid" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingName" } },
                                { kind: "Field", name: { kind: "Name", value: "carbonEmissionReductionPotential" } },
                                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                { kind: "Field", name: { kind: "Name", value: "lastUpdated" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "dataCoverage" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "dataCoverage" } },
                                            { kind: "Field", name: { kind: "Name", value: "energyType" } },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "energyTypeFromEquipmentData" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "energyTypeFromUtilityData" },
                                            },
                                            {
                                                kind: "Field",
                                                name: { kind: "Name", value: "equipmentDataHasSizeAndYear" },
                                            },
                                            { kind: "Field", name: { kind: "Name", value: "equipmentDataUploaded" } },
                                            { kind: "Field", name: { kind: "Name", value: "modellingStatus" } },
                                            { kind: "Field", name: { kind: "Name", value: "utilityDataUploaded" } },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "fundName" } },
                                { kind: "Field", name: { kind: "Name", value: "grossFloorArea" } },
                                {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            { kind: "Field", name: { kind: "Name", value: "streetAddress" } },
                                            { kind: "Field", name: { kind: "Name", value: "city" } },
                                            { kind: "Field", name: { kind: "Name", value: "stateProvince" } },
                                            { kind: "Field", name: { kind: "Name", value: "postalZipCode" } },
                                            { kind: "Field", name: { kind: "Name", value: "country" } },
                                            { kind: "Field", name: { kind: "Name", value: "latitude" } },
                                            { kind: "Field", name: { kind: "Name", value: "longitude" } },
                                            { kind: "Field", name: { kind: "Name", value: "climateZone" } },
                                        ],
                                    },
                                },
                                { kind: "Field", name: { kind: "Name", value: "netPresentValueIntensity" } },
                                { kind: "Field", name: { kind: "Name", value: "propertyName" } },
                                { kind: "Field", name: { kind: "Name", value: "tags" } },
                                { kind: "Field", name: { kind: "Name", value: "yearBuiltOriginal" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BuildingModelsTableQuery, BuildingModelsTableQueryVariables>;
export const BatchedRemodelBuildingModelsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "batchedRemodelBuildingModels" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUids" } },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "batchedRemodelBuildingModels" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUids" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUids" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "success" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<BatchedRemodelBuildingModelsMutation, BatchedRemodelBuildingModelsMutationVariables>;
export const UpdateBuildingNameDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "updateBuildingName" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingName" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "updateBuildingName" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingName" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingName" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "success" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateBuildingNameMutation, UpdateBuildingNameMutationVariables>;
export const UpdateBuildingModelDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: { kind: "Name", value: "updateBuildingModel" },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                    type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Uuid" } } },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "buildingProperties" } },
                    type: {
                        kind: "NonNullType",
                        type: { kind: "NamedType", name: { kind: "Name", value: "BuildingProperties" } },
                    },
                },
                {
                    kind: "VariableDefinition",
                    variable: { kind: "Variable", name: { kind: "Name", value: "carbonPolicyIds" } },
                    type: {
                        kind: "ListType",
                        type: {
                            kind: "NonNullType",
                            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: { kind: "Name", value: "updateBuildingModel" },
                        arguments: [
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingModelUid" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingModelUid" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "buildingProperties" },
                                value: { kind: "Variable", name: { kind: "Name", value: "buildingProperties" } },
                            },
                            {
                                kind: "Argument",
                                name: { kind: "Name", value: "carbonPolicyIds" },
                                value: { kind: "Variable", name: { kind: "Name", value: "carbonPolicyIds" } },
                            },
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                { kind: "Field", name: { kind: "Name", value: "error" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingModelRunUid" } },
                                { kind: "Field", name: { kind: "Name", value: "buildingModelUid" } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateBuildingModelMutation, UpdateBuildingModelMutationVariables>;
